// tslint:disable
/**
 * MyTripsAPI
 * My Trips API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Address representation
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * Moniker
     * @type {string}
     * @memberof Address
     */
    moniker?: string;
    /**
     * Street line 1
     * @type {string}
     * @memberof Address
     */
    streetLine: string;
    /**
     * Suburb or locality
     * @type {string}
     * @memberof Address
     */
    locality: string;
    /**
     * Area code
     * @type {string}
     * @memberof Address
     */
    areaCode: string;
    /**
     * State or region
     * @type {string}
     * @memberof Address
     */
    stateRegion: string;
    /**
     * Country
     * @type {string}
     * @memberof Address
     */
    country: string;
}
/**
 * set of statistics aggregated by trips, days, weeks, months and years of a trip attribute which only makes sense as an average (i.e. average speed)
 * @export
 * @interface AggregatedStatistics
 */
export interface AggregatedStatistics {
    /**
     * 
     * @type {Statistic}
     * @memberof AggregatedStatistics
     */
    trips?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AggregatedStatistics
     */
    days?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AggregatedStatistics
     */
    weeks?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AggregatedStatistics
     */
    months?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AggregatedStatistics
     */
    years?: Statistic;
}
/**
 * 
 * @export
 * @interface AveragableSummaryStatistics
 */
export interface AveragableSummaryStatistics {
    /**
     * 
     * @type {number}
     * @memberof AveragableSummaryStatistics
     */
    average: number;
    /**
     * 
     * @type {Statistic}
     * @memberof AveragableSummaryStatistics
     */
    trips?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AveragableSummaryStatistics
     */
    days?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AveragableSummaryStatistics
     */
    weeks?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AveragableSummaryStatistics
     */
    months?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof AveragableSummaryStatistics
     */
    years?: Statistic;
}
/**
 * set of statistics aggregated by trips, days, weeks, months and years of a trip attribute which only makes sense as an average (i.e. average speed)
 * @export
 * @interface AveragableSummaryStatisticsAllOf
 */
export interface AveragableSummaryStatisticsAllOf {
    /**
     * 
     * @type {number}
     * @memberof AveragableSummaryStatisticsAllOf
     */
    average: number;
}
/**
 * 
 * @export
 * @interface CarHealthDetail
 */
export interface CarHealthDetail {
    /**
     * 
     * @type {boolean}
     * @memberof CarHealthDetail
     */
    showContactButton?: boolean;
    /**
     * 
     * @type {Array<CarHealthDetailSection>}
     * @memberof CarHealthDetail
     */
    sections?: Array<CarHealthDetailSection>;
}
/**
 * 
 * @export
 * @interface CarHealthDetailSection
 */
export interface CarHealthDetailSection {
    /**
     * Type of the data within this section
     * @type {string}
     * @memberof CarHealthDetailSection
     */
    type: string;
    /**
     * Title of this section
     * @type {string}
     * @memberof CarHealthDetailSection
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CarHealthDetailSection
     */
    description?: string;
    /**
     * 
     * @type {Array<CarHealthDetailSectionIssue>}
     * @memberof CarHealthDetailSection
     */
    issues?: Array<CarHealthDetailSectionIssue>;
}
/**
 * 
 * @export
 * @interface CarHealthDetailSectionIssue
 */
export interface CarHealthDetailSectionIssue {
    /**
     * Title of this issue
     * @type {string}
     * @memberof CarHealthDetailSectionIssue
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CarHealthDetailSectionIssue
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CarHealthDetailSectionIssue
     */
    dtc?: string;
}
/**
 * 
 * @export
 * @interface CommonRoadSegment
 */
export interface CommonRoadSegment {
    /**
     * 
     * @type {string}
     * @memberof CommonRoadSegment
     */
    name: CommonRoadSegmentNameEnum;
    /**
     * 
     * @type {number}
     * @memberof CommonRoadSegment
     */
    minSpeed: number;
    /**
     * 
     * @type {number}
     * @memberof CommonRoadSegment
     */
    maxSpeed?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CommonRoadSegmentNameEnum {
    StopAndGo = 'stopAndGo',
    City = 'city',
    CountryRoad = 'countryRoad',
    Highway = 'highway'
}

/**
 * 
 * @export
 * @interface CommonRoadSegmentStatistics
 */
export interface CommonRoadSegmentStatistics {
    /**
     * 
     * @type {CommonRoadSegment}
     * @memberof CommonRoadSegmentStatistics
     */
    commonRoadSegment?: CommonRoadSegment;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof CommonRoadSegmentStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface CountStatistic
 */
export interface CountStatistic {
    /**
     * 
     * @type {number}
     * @memberof CountStatistic
     */
    total?: number;
}
/**
 * tripCount and statistics corresponding to trips attributes. This are null when tripCount is 0, meaning no trips were recorded.
 * @export
 * @interface CountableDiagramStatistics
 */
export interface CountableDiagramStatistics {
    /**
     * 
     * @type {SummableStatistic}
     * @memberof CountableDiagramStatistics
     */
    tripCount: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof CountableDiagramStatistics
     */
    distance?: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof CountableDiagramStatistics
     */
    duration?: SummableStatistic;
    /**
     * 
     * @type {Statistic}
     * @memberof CountableDiagramStatistics
     */
    speed?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof CountableDiagramStatistics
     */
    ecoScore?: Statistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof CountableDiagramStatistics
     */
    fuelConsumption?: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof CountableDiagramStatistics
     */
    emissions?: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof CountableDiagramStatistics
     */
    cost?: SummableStatistic;
}
/**
 * Represents a DTC reported by a Device for a given Vehicle
 * @export
 * @interface DTC
 */
export interface DTC {
    /**
     * The DTC id
     * @type {string}
     * @memberof DTC
     */
    id?: string;
    /**
     * DTC code recorded by the device
     * @type {string}
     * @memberof DTC
     */
    code?: string;
    /**
     * Description of the DTC. Description is available for generic codes. Default description is the standard On-board diagnostics(OBD) description.
     * @type {string}
     * @memberof DTC
     */
    description?: string;
    /**
     * DTC class code recorded by the device
     * @type {string}
     * @memberof DTC
     */
    classCode?: string;
    /**
     * Description of DTC class code
     * @type {string}
     * @memberof DTC
     */
    classDescription?: string;
    /**
     * The id of the device that captured the DTC
     * @type {string}
     * @memberof DTC
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof DTC
     */
    deviceTimestamp?: string;
    /**
     * Extended description of the DTC
     * @type {string}
     * @memberof DTC
     */
    extendedDescription?: string;
    /**
     * Number of times the fault has been reported
     * @type {number}
     * @memberof DTC
     */
    faultNumber?: number;
    /**
     * Indicates a pending or confirmed DTC
     * @type {string}
     * @memberof DTC
     */
    faultType?: string;
    /**
     * Reading of the vehicle odometer when the DTC is triggered
     * @type {number}
     * @memberof DTC
     */
    firstReportedOdometer?: number;
    /**
     * 
     * @type {string}
     * @memberof DTC
     */
    firstReportedTimestamp?: string;
    /**
     * Identifies if the DTC is current or not, that is, if the DTCs are the most recently scanned DTCs
     * @type {boolean}
     * @memberof DTC
     */
    isCurrent?: boolean;
    /**
     * Indicates if a mismatch event occurred during the trip that this DTC was recorded. True indicates a mismatch.
     * @type {boolean}
     * @memberof DTC
     */
    mismatched?: boolean;
    /**
     * Recommended action code for this DTC
     * @type {string}
     * @memberof DTC
     */
    recommendationCode?: string;
    /**
     * Recommended action description for this DTC.
     * @type {string}
     * @memberof DTC
     */
    recommendationDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DTC
     */
    reportedTimestamp?: string;
    /**
     * The id of the associated trip for this DTC
     * @type {string}
     * @memberof DTC
     */
    tripId?: string;
}
/**
 * 
 * @export
 * @interface DailyStatistics
 */
export interface DailyStatistics {
    /**
     * 
     * @type {string}
     * @memberof DailyStatistics
     */
    day: string;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof DailyStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface Daytime
 */
export interface Daytime {
    /**
     * 
     * @type {string}
     * @memberof Daytime
     */
    name: DaytimeNameEnum;
    /**
     * 
     * @type {number}
     * @memberof Daytime
     */
    from: number;
    /**
     * 
     * @type {number}
     * @memberof Daytime
     */
    to: number;
}

/**
    * @export
    * @enum {string}
    */
export enum DaytimeNameEnum {
    Morning = 'morning',
    Midday = 'midday',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Night = 'night'
}

/**
 * 
 * @export
 * @interface DaytimeStatistics
 */
export interface DaytimeStatistics {
    /**
     * 
     * @type {Daytime}
     * @memberof DaytimeStatistics
     */
    daytime: Daytime;
    /**
     * 
     * @type {CountableDiagramStatistics}
     * @memberof DaytimeStatistics
     */
    statistics: CountableDiagramStatistics;
}
/**
 * All relevant information regarding a specific SmartConnect device
 * @export
 * @interface Device
 */
export interface Device {
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    serialNumber: string;
    /**
     * 
     * @type {Location}
     * @memberof Device
     */
    lastKnownLocation?: Location;
}
/**
 * Basic information regarding a specific martConnect device (id and serial number)
 * @export
 * @interface DeviceInfo
 */
export interface DeviceInfo {
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    serialNumber: string;
}
/**
 * 
 * @export
 * @interface DirectedRoute
 */
export interface DirectedRoute {
    /**
     * Directed route id
     * @type {number}
     * @memberof DirectedRoute
     */
    id?: number;
    /**
     * 
     * @type {Zone}
     * @memberof DirectedRoute
     */
    from?: Zone;
    /**
     * 
     * @type {Zone}
     * @memberof DirectedRoute
     */
    to?: Zone;
    /**
     * distance in metres
     * @type {number}
     * @memberof DirectedRoute
     */
    distance?: number;
    /**
     * duration in milliseconds
     * @type {number}
     * @memberof DirectedRoute
     */
    duration?: number;
    /**
     * Trip route geometry (polyline). If creating trip and polyline is null, polyline will be calculated
     * @type {string}
     * @memberof DirectedRoute
     */
    routeGeometry?: string;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof DirectedRoute
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof DirectedRoute
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface DirectedRouteAllOf
 */
export interface DirectedRouteAllOf {
    /**
     * Directed route id
     * @type {number}
     * @memberof DirectedRouteAllOf
     */
    id?: number;
    /**
     * 
     * @type {Zone}
     * @memberof DirectedRouteAllOf
     */
    from?: Zone;
    /**
     * 
     * @type {Zone}
     * @memberof DirectedRouteAllOf
     */
    to?: Zone;
    /**
     * distance in metres
     * @type {number}
     * @memberof DirectedRouteAllOf
     */
    distance?: number;
    /**
     * duration in milliseconds
     * @type {number}
     * @memberof DirectedRouteAllOf
     */
    duration?: number;
    /**
     * Trip route geometry (polyline). If creating trip and polyline is null, polyline will be calculated
     * @type {string}
     * @memberof DirectedRouteAllOf
     */
    routeGeometry?: string;
}
/**
 * 
 * @export
 * @interface EcoScoreRecommendation
 */
export interface EcoScoreRecommendation {
    /**
     * 
     * @type {string}
     * @memberof EcoScoreRecommendation
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof EcoScoreRecommendation
     */
    description: string;
}
/**
 * 
 * @export
 * @interface EndZoneStatistics
 */
export interface EndZoneStatistics {
    /**
     * 
     * @type {Zone}
     * @memberof EndZoneStatistics
     */
    zone: Zone;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof EndZoneStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ErrorResponse
     */
    errors?: Array<Error>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ErrorType {
    OverlapTime = 'overlapTime',
    OverlapOdometer = 'overlapOdometer',
    GapOdometer = 'gapOdometer'
}

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {Location}
     * @memberof Event
     */
    location?: Location;
    /**
     * Unique code used to identify the type of event that has occurred
     * @type {string}
     * @memberof Event
     */
    type?: string;
}
/**
 * filters for the exports. All parameters are optional meaning no filtering would be done for missing parameters
 * @export
 * @interface ExportBody
 */
export interface ExportBody {
    /**
     * email to which the exports will be sent
     * @type {string}
     * @memberof ExportBody
     */
    email: string;
    /**
     * export formats desired. Supported values: \'pdf\', \'csv\', \'xlsx\'. Default value: \'pdf\'
     * @type {Array<ExportFormat>}
     * @memberof ExportBody
     */
    exportFormats?: Array<ExportFormat>;
    /**
     * export trips from the specified date-time. Format: rfc3339. Example 2019-09-27T15:00:30.000Z
     * @type {string}
     * @memberof ExportBody
     */
    from?: string;
    /**
     * export trips until the specified date-time. Format: rfc3339. Example 2019-09-27T20:00:30.000Z
     * @type {string}
     * @memberof ExportBody
     */
    until?: string;
    /**
     * export trips only for the given vehicle
     * @type {number}
     * @memberof ExportBody
     */
    vehicleId?: number;
    /**
     * exported trips must have one of the tags in the list
     * @type {Array<number>}
     * @memberof ExportBody
     */
    tagIds?: Array<number>;
    /**
     * exported trips must have one of the pilots in the list
     * @type {Array<number>}
     * @memberof ExportBody
     */
    pilotIds?: Array<number>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ExportFormat {
    Csv = 'csv',
    Pdf = 'pdf',
    Xlsx = 'xlsx'
}

/**
 * filters for the exports. From export date, vehicleId and email are required
 * @export
 * @interface ExportHealthBody
 */
export interface ExportHealthBody {
    /**
     * export trips only for the given vehicle
     * @type {number}
     * @memberof ExportHealthBody
     */
    vehicleId: number;
    /**
     * email to which the exports will be sent
     * @type {string}
     * @memberof ExportHealthBody
     */
    email: string;
    /**
     * export trips from the specified date-time. Format: rfc3339. Example 2019-09-27T15:00:30.000Z
     * @type {string}
     * @memberof ExportHealthBody
     */
    from: string;
    /**
     * export trips until the specified date-time. Format: rfc3339. Example 2019-09-27T20:00:30.000Z
     * @type {string}
     * @memberof ExportHealthBody
     */
    until?: string;
}
/**
 * Extra flexible data supplied by apps dependent on this api
 * @export
 * @interface ExtraData
 */
export interface ExtraData {
    /**
     * 
     * @type {SmartConnectData}
     * @memberof ExtraData
     */
    smartConnectData?: SmartConnectData;
    /**
     * 
     * @type {FslData}
     * @memberof ExtraData
     */
    fslData?: FslData;
}
/**
 * 
 * @export
 * @interface FslData
 */
export interface FslData {
    /**
     * Signature of the pilot confirming the trip data, e.g. the student signature during L license trips, syntax: a data url with base64 coded PNG: \"data:image/png;base64...\"
     * @type {string}
     * @memberof FslData
     */
    signaturePilot?: string;
    /**
     * Signature of co-pilot confirming the trip data, e.g. the parent signature during L license trips. syntax: see signaturePilot.
     * @type {string}
     * @memberof FslData
     */
    signatureCoPilot?: string;
    /**
     * A summary of the road condition of this trip, e.g. wet.
     * @type {string}
     * @memberof FslData
     */
    roadCondition?: string;
    /**
     * Summary of the route, useful when startInfo and endInfo is not given. e.g. Wien Graz.
     * @type {string}
     * @memberof FslData
     */
    routeSummary?: string;
    /**
     * The license plate number of the used vehicle, useful when no vehicleid is given, e.g. W-123, no syntax, free format.
     * @type {string}
     * @memberof FslData
     */
    licensePlate?: string;
    /**
     * The uuid of this trip, created by the client, before the trip is stored online.
     * @type {string}
     * @memberof FslData
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface FuelCapacityUpdateBody
 */
export interface FuelCapacityUpdateBody {
    /**
     * 
     * @type {number}
     * @memberof FuelCapacityUpdateBody
     */
    fuelCapacity: number;
}
/**
 * Calculated values are those calculated from different fuel stops whiel the measured one is the one shown by the device
 * @export
 * @enum {string}
 */
export enum FuelConsumptionType {
    CALCULATED = 'CALCULATED',
    MEASURED = 'MEASURED'
}

/**
 * 
 * @export
 * @interface FuelConsumptionTypeUpdateBody
 */
export interface FuelConsumptionTypeUpdateBody {
    /**
     * 
     * @type {FuelConsumptionType}
     * @memberof FuelConsumptionTypeUpdateBody
     */
    fuelConsumptionType: FuelConsumptionType;
}
/**
 * 
 * @export
 * @interface FuelCyclicStatistics
 */
export interface FuelCyclicStatistics {
    /**
     * 
     * @type {TimestampRange}
     * @memberof FuelCyclicStatistics
     */
    timestampRange: TimestampRange;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof FuelCyclicStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * fuel information associated to this trip
 * @export
 * @interface FuelInformation
 */
export interface FuelInformation {
    /**
     * litres of fuel consumed by this trip
     * @type {number}
     * @memberof FuelInformation
     */
    fuelConsumption?: number;
    /**
     * average per 100 km fuel consumed by this trip
     * @type {number}
     * @memberof FuelInformation
     */
    averageFuelConsumption?: number;
    /**
     * cost of fuel consumed by this trip
     * @type {number}
     * @memberof FuelInformation
     */
    fuelCost?: number;
}
/**
 * Fuel stop read model
 * @export
 * @interface FuelStop
 */
export interface FuelStop {
    /**
     * fuel stop identifier
     * @type {number}
     * @memberof FuelStop
     */
    id: number;
    /**
     * identity key of fuel stop owner
     * @type {string}
     * @memberof FuelStop
     */
    identityKey: string;
    /**
     * vehicle id corresponding to refueled vehicle
     * @type {number}
     * @memberof FuelStop
     */
    vehicleId: number;
    /**
     * id of the trip associated with this fuel stop
     * @type {number}
     * @memberof FuelStop
     */
    tripId: number;
    /**
     * 
     * @type {Pilot}
     * @memberof FuelStop
     */
    pilot?: Pilot;
    /**
     * kilometers travelled since last refuel stop
     * @type {number}
     * @memberof FuelStop
     */
    kmSinceLastFuelStop?: number;
    /**
     * average consumption measured in l / 100km. Meaning litres consumed every 100km
     * @type {number}
     * @memberof FuelStop
     */
    averageConsumption?: number;
    /**
     * amount payed per litre refueled
     * @type {number}
     * @memberof FuelStop
     */
    pricePerLitre: number;
    /**
     * time fuel stop took place
     * @type {string}
     * @memberof FuelStop
     */
    timestamp: string;
    /**
     * 
     * @type {Location}
     * @memberof FuelStop
     */
    location?: Location;
    /**
     * 
     * @type {Address}
     * @memberof FuelStop
     */
    address?: Address;
    /**
     * amount of litres refueled
     * @type {number}
     * @memberof FuelStop
     */
    litres: number;
    /**
     * total price payed
     * @type {number}
     * @memberof FuelStop
     */
    totalPrice: number;
    /**
     * whether the full tank was refueled or not
     * @type {boolean}
     * @memberof FuelStop
     */
    fullTank: boolean;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof FuelStop
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof FuelStop
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface FuelStopAllOf
 */
export interface FuelStopAllOf {
    /**
     * fuel stop identifier
     * @type {number}
     * @memberof FuelStopAllOf
     */
    id: number;
    /**
     * identity key of fuel stop owner
     * @type {string}
     * @memberof FuelStopAllOf
     */
    identityKey: string;
    /**
     * vehicle id corresponding to refueled vehicle
     * @type {number}
     * @memberof FuelStopAllOf
     */
    vehicleId: number;
    /**
     * id of the trip associated with this fuel stop
     * @type {number}
     * @memberof FuelStopAllOf
     */
    tripId: number;
    /**
     * 
     * @type {Pilot}
     * @memberof FuelStopAllOf
     */
    pilot?: Pilot;
    /**
     * kilometers travelled since last refuel stop
     * @type {number}
     * @memberof FuelStopAllOf
     */
    kmSinceLastFuelStop?: number;
    /**
     * average consumption measured in l / 100km. Meaning litres consumed every 100km
     * @type {number}
     * @memberof FuelStopAllOf
     */
    averageConsumption?: number;
    /**
     * amount payed per litre refueled
     * @type {number}
     * @memberof FuelStopAllOf
     */
    pricePerLitre: number;
}
/**
 * Fuel stop properties shared both by the read and write models
 * @export
 * @interface FuelStopBase
 */
export interface FuelStopBase {
    /**
     * time fuel stop took place
     * @type {string}
     * @memberof FuelStopBase
     */
    timestamp: string;
    /**
     * 
     * @type {Location}
     * @memberof FuelStopBase
     */
    location?: Location;
    /**
     * 
     * @type {Address}
     * @memberof FuelStopBase
     */
    address?: Address;
    /**
     * amount of litres refueled
     * @type {number}
     * @memberof FuelStopBase
     */
    litres: number;
    /**
     * total price payed
     * @type {number}
     * @memberof FuelStopBase
     */
    totalPrice: number;
    /**
     * whether the full tank was refueled or not
     * @type {boolean}
     * @memberof FuelStopBase
     */
    fullTank: boolean;
}
/**
 * Fuel stop write model
 * @export
 * @interface FuelStopMutation
 */
export interface FuelStopMutation {
    /**
     * time fuel stop took place
     * @type {string}
     * @memberof FuelStopMutation
     */
    timestamp: string;
    /**
     * 
     * @type {Location}
     * @memberof FuelStopMutation
     */
    location?: Location;
    /**
     * 
     * @type {Address}
     * @memberof FuelStopMutation
     */
    address?: Address;
    /**
     * amount of litres refueled
     * @type {number}
     * @memberof FuelStopMutation
     */
    litres: number;
    /**
     * total price payed
     * @type {number}
     * @memberof FuelStopMutation
     */
    totalPrice: number;
    /**
     * whether the full tank was refueled or not
     * @type {boolean}
     * @memberof FuelStopMutation
     */
    fullTank: boolean;
    /**
     * Id of the pilot which payed for the fuel
     * @type {number}
     * @memberof FuelStopMutation
     */
    pilotId?: number;
}
/**
 * 
 * @export
 * @interface FuelStopMutationAllOf
 */
export interface FuelStopMutationAllOf {
    /**
     * Id of the pilot which payed for the fuel
     * @type {number}
     * @memberof FuelStopMutationAllOf
     */
    pilotId?: number;
}
/**
 * 
 * @export
 * @interface FuelStopSuggestionsUpdateBody
 */
export interface FuelStopSuggestionsUpdateBody {
    /**
     * 
     * @type {boolean}
     * @memberof FuelStopSuggestionsUpdateBody
     */
    fuelStopSuggestions: boolean;
}
/**
 * Fuel Unit
 * @export
 * @enum {string}
 */
export enum FuelUnit {
    LITER = 'LITER',
    KG = 'KG',
    KWH = 'KWH'
}

/**
 * 
 * @export
 * @interface FuelUnitUpdateBody
 */
export interface FuelUnitUpdateBody {
    /**
     * 
     * @type {FuelUnit}
     * @memberof FuelUnitUpdateBody
     */
    fuelUnit: FuelUnit;
}
/**
 * 
 * @export
 * @interface GetTrip
 */
export interface GetTrip {
    /**
     * 
     * @type {Array<Event>}
     * @memberof GetTrip
     */
    events?: Array<Event>;
    /**
     * 
     * @type {Trip}
     * @memberof GetTrip
     */
    previous?: Trip;
    /**
     * 
     * @type {Trip}
     * @memberof GetTrip
     */
    next?: Trip;
    /**
     * Trip id
     * @type {number}
     * @memberof GetTrip
     */
    id: number;
    /**
     * 
     * @type {Pilot}
     * @memberof GetTrip
     */
    pilot?: Pilot;
    /**
     * 
     * @type {Tag}
     * @memberof GetTrip
     */
    tag?: Tag;
    /**
     * 
     * @type {TripInfo}
     * @memberof GetTrip
     */
    startInfo: TripInfo;
    /**
     * 
     * @type {TripInfo}
     * @memberof GetTrip
     */
    endInfo?: TripInfo;
    /**
     * collection of fuel stops made during trip or after it was finished ascendently sorted by timestamp
     * @type {Array<FuelStop>}
     * @memberof GetTrip
     */
    fuelStops?: Array<FuelStop>;
    /**
     * Duration in milliseconds the car was parked before starting this trip
     * @type {number}
     * @memberof GetTrip
     */
    parkingTimeBefore?: number;
    /**
     * Duration in milliseconds the car was parked after finishing this trip
     * @type {number}
     * @memberof GetTrip
     */
    parkingTimeAfter?: number;
    /**
     * Distance travelled in metres
     * @type {number}
     * @memberof GetTrip
     */
    distance?: number;
    /**
     * Duration of trip in milliseconds. This may be null if trip is still in progress.
     * @type {number}
     * @memberof GetTrip
     */
    duration?: number;
    /**
     * 
     * @type {FuelInformation}
     * @memberof GetTrip
     */
    fuelInformation?: FuelInformation;
    /**
     * 
     * @type {Array<TripChange>}
     * @memberof GetTrip
     */
    changes?: Array<TripChange>;
    /**
     * 
     * @type {Array<TripInvalidity>}
     * @memberof GetTrip
     */
    invalidities?: Array<TripInvalidity>;
    /**
     * OEAMTC KFZ Vehicle Id
     * @type {number}
     * @memberof GetTrip
     */
    vehicleId?: number;
    /**
     * 
     * @type {Array<TripStop>}
     * @memberof GetTrip
     */
    stops?: Array<TripStop>;
    /**
     * Note for a trip, for example: Pick up kids from soccer
     * @type {string}
     * @memberof GetTrip
     */
    note?: string;
    /**
     * Trip route geometry (polyline). If creating trip and polyline is null, polyline will be calculated
     * @type {string}
     * @memberof GetTrip
     */
    routeGeometry?: string;
    /**
     * 
     * @type {TripSource}
     * @memberof GetTrip
     */
    source: TripSource;
    /**
     * Trip is a fsl (fahrschule) trip
     * @type {boolean}
     * @memberof GetTrip
     */
    fsl?: boolean;
    /**
     * Trip is a work trip
     * @type {boolean}
     * @memberof GetTrip
     */
    work?: boolean;
    /**
     * 
     * @type {ExtraData}
     * @memberof GetTrip
     */
    extraData?: ExtraData;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof GetTrip
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof GetTrip
     */
    updatedAt: string;
}
/**
 * OEAMTC Trip representation
 * @export
 * @interface GetTripAllOf
 */
export interface GetTripAllOf {
    /**
     * 
     * @type {Array<Event>}
     * @memberof GetTripAllOf
     */
    events?: Array<Event>;
    /**
     * 
     * @type {Trip}
     * @memberof GetTripAllOf
     */
    previous?: Trip;
    /**
     * 
     * @type {Trip}
     * @memberof GetTripAllOf
     */
    next?: Trip;
}
/**
 * 
 * @export
 * @interface GisFavoriteSynchronizationResult
 */
export interface GisFavoriteSynchronizationResult {
    /**
     * 
     * @type {string}
     * @memberof GisFavoriteSynchronizationResult
     */
    result: GisFavoriteSynchronizationResultResultEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GisFavoriteSynchronizationResultResultEnum {
    Changed = 'changed',
    Unchanged = 'unchanged'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum IconNameTag {
    WorkIcon = 'tag_work_icon',
    PartyIcon = 'tag_party_icon',
    RestaurantIcon = 'tag_restaurant_icon',
    ShoppingIcon = 'tag_shopping_icon',
    PlayIcon = 'tag_play_icon',
    WellnessIcon = 'tag_wellness_icon',
    GymIcon = 'tag_gym_icon',
    FestivalIcon = 'tag_festival_icon',
    PictureIcon = 'tag_picture_icon',
    FreeRideIcon = 'tag_free_ride_icon',
    SleepIcon = 'tag_sleep_icon',
    HomeIcon = 'tag_home_icon',
    FamilyIcon = 'tag_family_icon',
    AirportIcon = 'tag_airport_icon',
    L17Icon = 'tag_l17_icon',
    WorkBriefcase1Icon = 'tag_work_briefcase_1_icon',
    WeightsIcon = 'tag_weights_icon',
    SportwatchIcon = 'tag_sportwatch_icon',
    ShoppingBasketIcon = 'tag_shopping_basket_icon',
    VacationIcon = 'tag_vacation_icon',
    TransportationWaterIcon = 'tag_transportation_water_icon',
    TransportationRailwayIcon = 'tag_transportation_railway_icon',
    TransportationBusIcon = 'tag_transportation_bus_icon',
    TransportationTaxiIcon = 'tag_transportation_taxi_icon',
    RoadIcon = 'tag_road_icon',
    EducationIcon = 'tag_education_icon',
    VisitDoorbellIcon = 'tag_visit_doorbell_icon',
    CarServiceIcon = 'tag_car_service_icon',
    HealthPillIcon = 'tag_health_pill_icon',
    HealthHeartRateIcon = 'tag_health_heart_rate_icon',
    BibleIcon = 'tag_bible_icon',
    PersonIcon = 'tag_person_icon'
}

/**
 * 
 * @export
 * @interface ImportBody
 */
export interface ImportBody {
    /**
     * 
     * @type {string}
     * @memberof ImportBody
     */
    email: string;
    /**
     * The trips to import as csv from the trip export
     * @type {string}
     * @memberof ImportBody
     */
    csv: string;
}
/**
 * Geo-location representation
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * Latitude of the location
     * @type {number}
     * @memberof Location
     */
    latitude: number;
    /**
     * Longitude of the location
     * @type {number}
     * @memberof Location
     */
    longitude: number;
}
/**
 * 
 * @export
 * @interface MaintenanceItem
 */
export interface MaintenanceItem {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItem
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItem
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItem
     */
    startOdometer?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceItem
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItem
     */
    datePeriodValue?: number;
    /**
     * 
     * @type {MaintenanceItemDatePeriodUnit}
     * @memberof MaintenanceItem
     */
    datePeriodUnit?: MaintenanceItemDatePeriodUnit;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItem
     */
    odometerPeriodKmValue?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceItem
     */
    periodRelativ?: boolean;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof MaintenanceItem
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof MaintenanceItem
     */
    updatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItem
     */
    abonnementId?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItem
     */
    vehicleId?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItem
     */
    firstReminderDate?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItem
     */
    firstReminderOdometer?: number;
    /**
     * 
     * @type {MaintenanceItemType}
     * @memberof MaintenanceItem
     */
    itemType?: MaintenanceItemType;
}
/**
 * 
 * @export
 * @interface MaintenanceItemActive
 */
export interface MaintenanceItemActive {
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceItemActive
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface MaintenanceItemAllOf
 */
export interface MaintenanceItemAllOf {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItemAllOf
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItemAllOf
     */
    abonnementId?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItemAllOf
     */
    vehicleId?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItemAllOf
     */
    firstReminderDate?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItemAllOf
     */
    firstReminderOdometer?: number;
    /**
     * 
     * @type {MaintenanceItemType}
     * @memberof MaintenanceItemAllOf
     */
    itemType?: MaintenanceItemType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MaintenanceItemDatePeriodUnit {
    YEAR = 'YEAR',
    MONTH = 'MONTH',
    WEEK = 'WEEK',
    DAY = 'DAY'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum MaintenanceItemEnumUrgency {
    NotUrgent = 'notUrgent',
    Due = 'due',
    Overdue = 'overdue'
}

/**
 * Contains information about a maintenance recommendation
 * @export
 * @interface MaintenanceItemHealth
 */
export interface MaintenanceItemHealth {
    /**
     * id of the maintainance item
     * @type {string}
     * @memberof MaintenanceItemHealth
     */
    id?: string;
    /**
     * Very short text naming this item
     * @type {string}
     * @memberof MaintenanceItemHealth
     */
    name?: string;
    /**
     * A very short text indicating how much time or kilometers the user has remaining before this items becomes overdue.
     * @type {string}
     * @memberof MaintenanceItemHealth
     */
    remainingTimeText?: string;
    /**
     * 
     * @type {MaintenanceItemEnumUrgency}
     * @memberof MaintenanceItemHealth
     */
    urgencyIndicator?: MaintenanceItemEnumUrgency;
    /**
     * 
     * @type {MaintenanceItemTrigger}
     * @memberof MaintenanceItemHealth
     */
    dateTrigger?: MaintenanceItemTrigger;
    /**
     * 
     * @type {MaintenanceItemTrigger}
     * @memberof MaintenanceItemHealth
     */
    odometerTrigger?: MaintenanceItemTrigger;
    /**
     * 
     * @type {MaintenanceItemType}
     * @memberof MaintenanceItemHealth
     */
    itemType?: MaintenanceItemType;
}
/**
 * 
 * @export
 * @interface MaintenanceItemMutation
 */
export interface MaintenanceItemMutation {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItemMutation
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItemMutation
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItemMutation
     */
    startOdometer?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceItemMutation
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItemMutation
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItemMutation
     */
    datePeriodValue?: number;
    /**
     * 
     * @type {MaintenanceItemDatePeriodUnit}
     * @memberof MaintenanceItemMutation
     */
    datePeriodUnit?: MaintenanceItemDatePeriodUnit;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceItemMutation
     */
    odometerPeriodKmValue?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceItemMutation
     */
    periodRelativ?: boolean;
}
/**
 * 
 * @export
 * @interface MaintenanceItemTrigger
 */
export interface MaintenanceItemTrigger {
    /**
     * in km or days (negative means shortly before due date, positive is after)
     * @type {number}
     * @memberof MaintenanceItemTrigger
     */
    due: number;
    /**
     * in km or days (negative means shortly before due date, positive is after)
     * @type {number}
     * @memberof MaintenanceItemTrigger
     */
    overdue: number;
    /**
     * period in km or days with custom text, like \'Alle 100 km\' or \'Jährlich\'
     * @type {string}
     * @memberof MaintenanceItemTrigger
     */
    period?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MaintenanceItemType {
    AntiFreeze = 'Anti_freeze',
    Oil = 'Oil',
    P57a = 'P57a',
    WinterTire = 'Winter_tire',
    Vignette = 'Vignette'
}

/**
 * 
 * @export
 * @interface MaintenanceItemUpdateBody
 */
export interface MaintenanceItemUpdateBody {
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceItemUpdateBody
     */
    checked: boolean;
}
/**
 * 
 * @export
 * @interface MergeBreakThresholdUpdateBody
 */
export interface MergeBreakThresholdUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof MergeBreakThresholdUpdateBody
     */
    mergeBreakThreshold: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface Modifiable
 */
export interface Modifiable {
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof Modifiable
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof Modifiable
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface Month
 */
export interface Month {
    /**
     * 
     * @type {number}
     * @memberof Month
     */
    month: number;
    /**
     * 
     * @type {number}
     * @memberof Month
     */
    year: number;
}
/**
 * 
 * @export
 * @interface MonthlyStatistics
 */
export interface MonthlyStatistics {
    /**
     * 
     * @type {Month}
     * @memberof MonthlyStatistics
     */
    month: Month;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof MonthlyStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * event id this notification corresponds to
     * @type {string}
     * @memberof Notification
     */
    event: string;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    active?: boolean;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof Notification
     */
    channels: Array<NotificationChannelEnum>;
}
/**
 * 
 * @export
 * @interface NotificationActive
 */
export interface NotificationActive {
    /**
     * event id this notification corresponds to
     * @type {string}
     * @memberof NotificationActive
     */
    event: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationActive
     */
    active: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NotificationChannelEnum {
    SMS = 'SMS',
    Email = 'Email',
    AppPush = 'AppPush'
}

/**
 * 
 * @export
 * @interface NotificationData
 */
export interface NotificationData {
    /**
     * event id this notification corresponds to
     * @type {string}
     * @memberof NotificationData
     */
    event: string;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof NotificationData
     */
    channels: Array<NotificationChannelEnum>;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof NotificationData
     */
    availableChannels: Array<NotificationChannelEnum>;
    /**
     * Notification name
     * @type {string}
     * @memberof NotificationData
     */
    title: string;
    /**
     * notification description
     * @type {string}
     * @memberof NotificationData
     */
    description: string;
    /**
     * order in which this notification should be displayed
     * @type {number}
     * @memberof NotificationData
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationData
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface NotificationDataResponse
 */
export interface NotificationDataResponse {
    /**
     * 
     * @type {Array<NotificationData>}
     * @memberof NotificationDataResponse
     */
    data: Array<NotificationData>;
}
/**
 * 
 * @export
 * @interface NotificationDataResponseAllOf
 */
export interface NotificationDataResponseAllOf {
    /**
     * 
     * @type {Array<NotificationData>}
     * @memberof NotificationDataResponseAllOf
     */
    data: Array<NotificationData>;
}
/**
 * 
 * @export
 * @interface NotificationVehicleActiveUpdateRequest
 */
export interface NotificationVehicleActiveUpdateRequest {
    /**
     * 
     * @type {NotificationActive}
     * @memberof NotificationVehicleActiveUpdateRequest
     */
    data: NotificationActive;
}
/**
 * 
 * @export
 * @interface NotificationVehicleUpdateRequest
 */
export interface NotificationVehicleUpdateRequest {
    /**
     * 
     * @type {Notification}
     * @memberof NotificationVehicleUpdateRequest
     */
    data: Notification;
}
/**
 * Pilot representation
 * @export
 * @interface Pilot
 */
export interface Pilot {
    /**
     * Pilot id
     * @type {number}
     * @memberof Pilot
     */
    id: number;
    /**
     * First name of the pilot
     * @type {string}
     * @memberof Pilot
     */
    firstname?: string;
    /**
     * Last name of the pilot
     * @type {string}
     * @memberof Pilot
     */
    lastname?: string;
    /**
     * Arbitrary nickname for the pilot
     * @type {string}
     * @memberof Pilot
     */
    nickname?: string;
    /**
     * Initial of the pilot - default: first letter of firstname
     * @type {string}
     * @memberof Pilot
     */
    initial?: string;
    /**
     * RGB hex pilot color, including leading #
     * @type {string}
     * @memberof Pilot
     */
    color: string;
    /**
     * cknr of the suggestion
     * @type {number}
     * @memberof Pilot
     */
    cknr?: number;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof Pilot
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof Pilot
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface PilotAllOf
 */
export interface PilotAllOf {
    /**
     * Pilot id
     * @type {number}
     * @memberof PilotAllOf
     */
    id: number;
}
/**
 * 
 * @export
 * @interface PilotHighlight
 */
export interface PilotHighlight {
    /**
     * 
     * @type {number}
     * @memberof PilotHighlight
     */
    count: number;
    /**
     * 
     * @type {Pilot}
     * @memberof PilotHighlight
     */
    pilot: Pilot;
}
/**
 * Pilot mutation properties representation
 * @export
 * @interface PilotMutation
 */
export interface PilotMutation {
    /**
     * First name of the pilot
     * @type {string}
     * @memberof PilotMutation
     */
    firstname?: string;
    /**
     * Last name of the pilot
     * @type {string}
     * @memberof PilotMutation
     */
    lastname?: string;
    /**
     * Arbitrary nickname for the pilot
     * @type {string}
     * @memberof PilotMutation
     */
    nickname?: string;
    /**
     * Initial of the pilot - default: first letter of firstname
     * @type {string}
     * @memberof PilotMutation
     */
    initial?: string;
    /**
     * RGB hex pilot color, including leading #
     * @type {string}
     * @memberof PilotMutation
     */
    color: string;
    /**
     * cknr of the suggestion
     * @type {number}
     * @memberof PilotMutation
     */
    cknr?: number;
}
/**
 * 
 * @export
 * @interface PilotStatistics
 */
export interface PilotStatistics {
    /**
     * 
     * @type {Pilot}
     * @memberof PilotStatistics
     */
    pilot?: Pilot;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof PilotStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * Response of a \'read\' operation containing a single resource
 * @export
 * @interface ResponseSingle
 */
export interface ResponseSingle {
    /**
     * 
     * @type {object}
     * @memberof ResponseSingle
     */
    data: object;
}
/**
 * a route is simply represented by a set of two zones
 * @export
 * @interface Route
 */
export interface Route {
    /**
     * 
     * @type {Array<Zone>}
     * @memberof Route
     */
    zones: Array<Zone>;
}
/**
 * 
 * @export
 * @interface RouteHighlight
 */
export interface RouteHighlight {
    /**
     * 
     * @type {number}
     * @memberof RouteHighlight
     */
    count: number;
    /**
     * 
     * @type {Route}
     * @memberof RouteHighlight
     */
    route: Route;
}
/**
 * 
 * @export
 * @interface RouteStatistics
 */
export interface RouteStatistics {
    /**
     * 
     * @type {Route}
     * @memberof RouteStatistics
     */
    route: Route;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof RouteStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface Rule
 */
export interface Rule {
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Rule
     */
    vehicles: Array<number>;
    /**
     * 
     * @type {Array<RuleTriggerEnum>}
     * @memberof Rule
     */
    triggers: Array<RuleTriggerEnum>;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    personalZoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    tagId?: string;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    pilotId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Rule
     */
    active?: boolean;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof Rule
     */
    channels: Array<NotificationChannelEnum>;
}
/**
 * 
 * @export
 * @interface RuleActive
 */
export interface RuleActive {
    /**
     * 
     * @type {boolean}
     * @memberof RuleActive
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface RuleMutation
 */
export interface RuleMutation {
    /**
     * 
     * @type {string}
     * @memberof RuleMutation
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleMutation
     */
    vehicles: Array<number>;
    /**
     * 
     * @type {Array<RuleTriggerEnum>}
     * @memberof RuleMutation
     */
    triggers: Array<RuleTriggerEnum>;
    /**
     * 
     * @type {string}
     * @memberof RuleMutation
     */
    personalZoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleMutation
     */
    tagId?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleMutation
     */
    pilotId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RuleMutation
     */
    active?: boolean;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof RuleMutation
     */
    channels: Array<NotificationChannelEnum>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum RuleTriggerEnum {
    TripStart = 'tripStart',
    TripEnd = 'tripEnd'
}

/**
 * 
 * @export
 * @interface RuleV2
 */
export interface RuleV2 {
    /**
     * 
     * @type {string}
     * @memberof RuleV2
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RuleV2
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleV2
     */
    vehicleIds: Array<number>;
    /**
     * 
     * @type {Array<RuleTriggerEnum>}
     * @memberof RuleV2
     */
    triggers: Array<RuleTriggerEnum>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleV2
     */
    zoneIds: Array<number>;
    /**
     * 
     * @type {Timeframe}
     * @memberof RuleV2
     */
    triggerTimeframe?: Timeframe;
    /**
     * 
     * @type {string}
     * @memberof RuleV2
     */
    tagId?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleV2
     */
    pilotId?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleV2
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RuleV2
     */
    work?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleV2
     */
    active?: boolean;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof RuleV2
     */
    channels: Array<NotificationChannelEnum>;
}
/**
 * 
 * @export
 * @interface RuleV2AllOf
 */
export interface RuleV2AllOf {
    /**
     * 
     * @type {string}
     * @memberof RuleV2AllOf
     */
    id: string;
}
/**
 * 
 * @export
 * @interface RuleV2Mutation
 */
export interface RuleV2Mutation {
    /**
     * 
     * @type {string}
     * @memberof RuleV2Mutation
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleV2Mutation
     */
    vehicleIds: Array<number>;
    /**
     * 
     * @type {Array<RuleTriggerEnum>}
     * @memberof RuleV2Mutation
     */
    triggers: Array<RuleTriggerEnum>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleV2Mutation
     */
    zoneIds: Array<number>;
    /**
     * 
     * @type {Timeframe}
     * @memberof RuleV2Mutation
     */
    triggerTimeframe?: Timeframe;
    /**
     * 
     * @type {string}
     * @memberof RuleV2Mutation
     */
    tagId?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleV2Mutation
     */
    pilotId?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleV2Mutation
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RuleV2Mutation
     */
    work?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleV2Mutation
     */
    active?: boolean;
    /**
     * 
     * @type {Array<NotificationChannelEnum>}
     * @memberof RuleV2Mutation
     */
    channels: Array<NotificationChannelEnum>;
}
/**
 * 
 * @export
 * @interface SetupRequestUpdate
 */
export interface SetupRequestUpdate {
    /**
     * 
     * @type {SetupUpdate}
     * @memberof SetupRequestUpdate
     */
    data?: SetupUpdate;
}
/**
 * 
 * @export
 * @interface SetupUpdate
 */
export interface SetupUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof SetupUpdate
     */
    done?: boolean;
}
/**
 * Smart connect related extra data
 * @export
 * @interface SmartConnectData
 */
export interface SmartConnectData {
    /**
     * Tsh trip unique identifier
     * @type {string}
     * @memberof SmartConnectData
     */
    tshTripUuid?: string;
    /**
     * Tsh driver unique identifier
     * @type {string}
     * @memberof SmartConnectData
     */
    tshDriverUuid?: string;
    /**
     * Tsh vehicle unique identifier
     * @type {string}
     * @memberof SmartConnectData
     */
    tshVehicleUuid?: string;
    /**
     * trip average speed in km/h
     * @type {number}
     * @memberof SmartConnectData
     */
    averageSpeed?: number;
    /**
     * trip maximum speed in km/h
     * @type {number}
     * @memberof SmartConnectData
     */
    maximumSpeed?: number;
    /**
     * trip average rpm
     * @type {number}
     * @memberof SmartConnectData
     */
    averageRpm?: number;
    /**
     * trip maximum rpm
     * @type {number}
     * @memberof SmartConnectData
     */
    maximumRpm?: number;
    /**
     * total trip fuel consumption
     * @type {number}
     * @memberof SmartConnectData
     */
    fuelConsumption?: number;
    /**
     * trip fuel level at the start of the trip
     * @type {number}
     * @memberof SmartConnectData
     */
    startFuelLevel?: number;
    /**
     * trip fuel level at the end of the trip
     * @type {number}
     * @memberof SmartConnectData
     */
    endFuelLevel?: number;
    /**
     * trip CO2 emissions
     * @type {number}
     * @memberof SmartConnectData
     */
    emissions?: number;
    /**
     * 
     * @type {SmartConnectDataScore}
     * @memberof SmartConnectData
     */
    score?: SmartConnectDataScore;
}
/**
 * trip multiple scores
 * @export
 * @interface SmartConnectDataScore
 */
export interface SmartConnectDataScore {
    /**
     * Calculated score for idling based on the idling histogram
     * @type {number}
     * @memberof SmartConnectDataScore
     */
    idlingScore?: number;
    /**
     * Calculated score for speeding based on the speed histogram
     * @type {number}
     * @memberof SmartConnectDataScore
     */
    speedingScore?: number;
    /**
     * Calculated score for deceleration based on the braking histogram
     * @type {number}
     * @memberof SmartConnectDataScore
     */
    brakingScore?: number;
    /**
     * Calculated core for acceleration based on the acceleration histogram
     * @type {number}
     * @memberof SmartConnectDataScore
     */
    accelerationScore?: number;
    /**
     * Calculated score that represents the degree of eco-friendly driving behaviour of the driver based on idlingScore, speedingScore, brakingScore, and accelarationScore
     * @type {number}
     * @memberof SmartConnectDataScore
     */
    totalEcoScore?: number;
}
/**
 * 
 * @export
 * @interface SmartConnectVehicle
 */
export interface SmartConnectVehicle {
    /**
     * 
     * @type {number}
     * @memberof SmartConnectVehicle
     */
    vehicleId?: number;
    /**
     * 
     * @type {number}
     * @memberof SmartConnectVehicle
     */
    odometer?: number;
    /**
     * 
     * @type {string}
     * @memberof SmartConnectVehicle
     */
    odometerType?: SmartConnectVehicleOdometerTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SmartConnectVehicleOdometerTypeEnum {
    Gps = 'gps',
    Can = 'can'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SpecialTag {
    Work = 'work',
    Private = 'private',
    L17 = 'l17',
    None = 'none'
}

/**
 * statistics from a trip attribute (i.e. distance): mean, standard deviation, median, maximum and minimum values
 * @export
 * @interface Statistic
 */
export interface Statistic {
    /**
     * 
     * @type {number}
     * @memberof Statistic
     */
    mean: number;
    /**
     * 
     * @type {number}
     * @memberof Statistic
     */
    std: number;
    /**
     * 
     * @type {number}
     * @memberof Statistic
     */
    median: number;
    /**
     * 
     * @type {number}
     * @memberof Statistic
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof Statistic
     */
    min: number;
}
/**
 * 
 * @export
 * @interface StatisticsCategoricalDiagrams
 */
export interface StatisticsCategoricalDiagrams {
    /**
     * 
     * @type {Array<DaytimeStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    daytimes?: Array<DaytimeStatistics>;
    /**
     * 
     * @type {Array<WeekdayStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    weekdays?: Array<WeekdayStatistics>;
    /**
     * 
     * @type {Array<CommonRoadSegmentStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    commonRoadSegments?: Array<CommonRoadSegmentStatistics>;
    /**
     * 
     * @type {Array<TagStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    tags?: Array<TagStatistics>;
    /**
     * 
     * @type {Array<PilotStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    pilots?: Array<PilotStatistics>;
    /**
     * 
     * @type {Array<EndZoneStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    endZones?: Array<EndZoneStatistics>;
    /**
     * 
     * @type {Array<RouteStatistics>}
     * @memberof StatisticsCategoricalDiagrams
     */
    routes?: Array<RouteStatistics>;
}
/**
 * 
 * @export
 * @interface StatisticsHighlights
 */
export interface StatisticsHighlights {
    /**
     * 
     * @type {RouteHighlight}
     * @memberof StatisticsHighlights
     */
    mostCommonRoute?: RouteHighlight;
    /**
     * 
     * @type {ZoneHighlight}
     * @memberof StatisticsHighlights
     */
    mostCommonZone?: ZoneHighlight;
    /**
     * 
     * @type {PilotHighlight}
     * @memberof StatisticsHighlights
     */
    mostCommonPilot?: PilotHighlight;
    /**
     * 
     * @type {TagHighlight}
     * @memberof StatisticsHighlights
     */
    mostCommonTag?: TagHighlight;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumSpeed?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumSpeedTripId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumDurationTripId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumDistanceTripId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumEcoScore?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumEcoScoreTripId?: number;
    /**
     * fuel consumption is given in liters over 100km (l / 100km)
     * @type {number}
     * @memberof StatisticsHighlights
     */
    minimumFuelConsumption?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    minimumFuelConsumptionTripId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumRpm?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumRpmTripId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumCost?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsHighlights
     */
    maximumCostTripId?: number;
}
/**
 * 
 * @export
 * @interface StatisticsRouteGeometries
 */
export interface StatisticsRouteGeometries {
    /**
     * Amount of route geometries
     * @type {number}
     * @memberof StatisticsRouteGeometries
     */
    count?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatisticsRouteGeometries
     */
    routeGeometries?: Array<string>;
}
/**
 * 
 * @export
 * @interface StatisticsSummary
 */
export interface StatisticsSummary {
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    tripCount: SummaryStatistics;
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    distance?: SummaryStatistics;
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummary
     */
    speed?: AveragableSummaryStatistics;
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    duration?: SummaryStatistics;
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    parkingTime?: SummaryStatistics;
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummary
     */
    rpm?: AveragableSummaryStatistics;
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    fuelConsumption?: SummaryStatistics;
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    emissions?: SummaryStatistics;
    /**
     * 
     * @type {SummaryStatistics}
     * @memberof StatisticsSummary
     */
    cost?: SummaryStatistics;
    /**
     * 
     * @type {StatisticsSummaryScore}
     * @memberof StatisticsSummary
     */
    score?: StatisticsSummaryScore;
}
/**
 * 
 * @export
 * @interface StatisticsSummaryScore
 */
export interface StatisticsSummaryScore {
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummaryScore
     */
    idlingScore: AveragableSummaryStatistics;
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummaryScore
     */
    speedingScore: AveragableSummaryStatistics;
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummaryScore
     */
    brakingScore: AveragableSummaryStatistics;
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummaryScore
     */
    accelerationScore: AveragableSummaryStatistics;
    /**
     * 
     * @type {AveragableSummaryStatistics}
     * @memberof StatisticsSummaryScore
     */
    totalEcoScore: AveragableSummaryStatistics;
}
/**
 * 
 * @export
 * @interface StatisticsTimeDiagrams
 */
export interface StatisticsTimeDiagrams {
    /**
     * 
     * @type {Array<DailyStatistics>}
     * @memberof StatisticsTimeDiagrams
     */
    daily?: Array<DailyStatistics>;
    /**
     * 
     * @type {Array<WeeklyStatistics>}
     * @memberof StatisticsTimeDiagrams
     */
    weekly?: Array<WeeklyStatistics>;
    /**
     * 
     * @type {Array<MonthlyStatistics>}
     * @memberof StatisticsTimeDiagrams
     */
    monthly?: Array<MonthlyStatistics>;
    /**
     * 
     * @type {Array<YearlyStatistics>}
     * @memberof StatisticsTimeDiagrams
     */
    yearly?: Array<YearlyStatistics>;
    /**
     * 
     * @type {Array<FuelCyclicStatistics>}
     * @memberof StatisticsTimeDiagrams
     */
    fuelCyclic?: Array<FuelCyclicStatistics>;
}
/**
 * Suggested fuel stop
 * @export
 * @interface SuggestedFuelStop
 */
export interface SuggestedFuelStop {
    /**
     * 
     * @type {SuggestedFuelStopTrigger}
     * @memberof SuggestedFuelStop
     */
    trigger: SuggestedFuelStopTrigger;
    /**
     * 
     * @type {string}
     * @memberof SuggestedFuelStop
     */
    timestamp: string;
    /**
     * 
     * @type {Location}
     * @memberof SuggestedFuelStop
     */
    location: Location;
    /**
     * 
     * @type {Address}
     * @memberof SuggestedFuelStop
     */
    address: Address;
    /**
     * estimated litres
     * @type {number}
     * @memberof SuggestedFuelStop
     */
    litres?: number;
    /**
     * estimated total price
     * @type {number}
     * @memberof SuggestedFuelStop
     */
    totalPrice?: number;
}
/**
 * trigger types for suggested fuel stop
 * @export
 * @enum {string}
 */
export enum SuggestedFuelStopTrigger {
    AVERAGEDISTANCE = 'AVERAGE_DISTANCE',
    NEARFUELSTOP = 'NEAR_FUEL_STOP',
    FUELSPIKE = 'FUEL_SPIKE',
    ENITANKBONUS = 'ENI_TANKBONUS'
}

/**
 * statistics from a trip attribute (i.e. distance): sum, mean, standard deviation, median, maximum and minimum values
 * @export
 * @interface SummableStatistic
 */
export interface SummableStatistic {
    /**
     * 
     * @type {number}
     * @memberof SummableStatistic
     */
    sum?: number;
    /**
     * 
     * @type {number}
     * @memberof SummableStatistic
     */
    mean: number;
    /**
     * 
     * @type {number}
     * @memberof SummableStatistic
     */
    std: number;
    /**
     * 
     * @type {number}
     * @memberof SummableStatistic
     */
    median: number;
    /**
     * 
     * @type {number}
     * @memberof SummableStatistic
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof SummableStatistic
     */
    min: number;
}
/**
 * 
 * @export
 * @interface SummableStatisticAllOf
 */
export interface SummableStatisticAllOf {
    /**
     * 
     * @type {number}
     * @memberof SummableStatisticAllOf
     */
    sum?: number;
}
/**
 * 
 * @export
 * @interface SummaryStatistics
 */
export interface SummaryStatistics {
    /**
     * 
     * @type {number}
     * @memberof SummaryStatistics
     */
    total: number;
    /**
     * 
     * @type {Statistic}
     * @memberof SummaryStatistics
     */
    trips?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof SummaryStatistics
     */
    days?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof SummaryStatistics
     */
    weeks?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof SummaryStatistics
     */
    months?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof SummaryStatistics
     */
    years?: Statistic;
}
/**
 * set of statistics aggregated by trips, days, weeks, months and years of a trip attribute (i.e. distance). Trips aggregation may be null for attributes which makes no sense aggregrating by trip, i.e. parking hours and trip count
 * @export
 * @interface SummaryStatisticsAllOf
 */
export interface SummaryStatisticsAllOf {
    /**
     * 
     * @type {number}
     * @memberof SummaryStatisticsAllOf
     */
    total: number;
}
/**
 * Tag representation. They act as a category for a trip
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * Tag id
     * @type {number}
     * @memberof Tag
     */
    id: number;
    /**
     * 
     * @type {SpecialTag}
     * @memberof Tag
     */
    specialTag?: SpecialTag;
    /**
     * The user assigned tag name
     * @type {string}
     * @memberof Tag
     */
    name: string;
    /**
     * RGB hex tag color, including leading #
     * @type {string}
     * @memberof Tag
     */
    color: string;
    /**
     * 
     * @type {IconNameTag}
     * @memberof Tag
     */
    iconName: IconNameTag;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof Tag
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof Tag
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface TagAllOf
 */
export interface TagAllOf {
    /**
     * Tag id
     * @type {number}
     * @memberof TagAllOf
     */
    id: number;
    /**
     * 
     * @type {SpecialTag}
     * @memberof TagAllOf
     */
    specialTag?: SpecialTag;
}
/**
 * 
 * @export
 * @interface TagHighlight
 */
export interface TagHighlight {
    /**
     * 
     * @type {number}
     * @memberof TagHighlight
     */
    count: number;
    /**
     * 
     * @type {Tag}
     * @memberof TagHighlight
     */
    tag: Tag;
}
/**
 * Tag mutation properties representation
 * @export
 * @interface TagMutation
 */
export interface TagMutation {
    /**
     * The user assigned tag name
     * @type {string}
     * @memberof TagMutation
     */
    name: string;
    /**
     * RGB hex tag color, including leading #
     * @type {string}
     * @memberof TagMutation
     */
    color: string;
    /**
     * 
     * @type {IconNameTag}
     * @memberof TagMutation
     */
    iconName: IconNameTag;
}
/**
 * 
 * @export
 * @interface TagStatistics
 */
export interface TagStatistics {
    /**
     * 
     * @type {Tag}
     * @memberof TagStatistics
     */
    tag?: Tag;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof TagStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface Timeframe
 */
export interface Timeframe {
    /**
     * 
     * @type {string}
     * @memberof Timeframe
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof Timeframe
     */
    until: string;
}
/**
 * represents a timestamp range
 * @export
 * @interface TimestampRange
 */
export interface TimestampRange {
    /**
     * start of the range
     * @type {string}
     * @memberof TimestampRange
     */
    from: string;
    /**
     * end of the range
     * @type {string}
     * @memberof TimestampRange
     */
    to: string;
}
/**
 * 
 * @export
 * @interface TimestampRequestBody
 */
export interface TimestampRequestBody {
    /**
     * 
     * @type {string}
     * @memberof TimestampRequestBody
     */
    timestamp?: string;
}
/**
 * 
 * @export
 * @interface Trip
 */
export interface Trip {
    /**
     * Trip id
     * @type {number}
     * @memberof Trip
     */
    id: number;
    /**
     * 
     * @type {Pilot}
     * @memberof Trip
     */
    pilot?: Pilot;
    /**
     * 
     * @type {Tag}
     * @memberof Trip
     */
    tag?: Tag;
    /**
     * 
     * @type {TripInfo}
     * @memberof Trip
     */
    startInfo: TripInfo;
    /**
     * 
     * @type {TripInfo}
     * @memberof Trip
     */
    endInfo?: TripInfo;
    /**
     * collection of fuel stops made during trip or after it was finished ascendently sorted by timestamp
     * @type {Array<FuelStop>}
     * @memberof Trip
     */
    fuelStops?: Array<FuelStop>;
    /**
     * Duration in milliseconds the car was parked before starting this trip
     * @type {number}
     * @memberof Trip
     */
    parkingTimeBefore?: number;
    /**
     * Duration in milliseconds the car was parked after finishing this trip
     * @type {number}
     * @memberof Trip
     */
    parkingTimeAfter?: number;
    /**
     * Distance travelled in metres
     * @type {number}
     * @memberof Trip
     */
    distance?: number;
    /**
     * Duration of trip in milliseconds. This may be null if trip is still in progress.
     * @type {number}
     * @memberof Trip
     */
    duration?: number;
    /**
     * 
     * @type {FuelInformation}
     * @memberof Trip
     */
    fuelInformation?: FuelInformation;
    /**
     * 
     * @type {Array<TripChange>}
     * @memberof Trip
     */
    changes?: Array<TripChange>;
    /**
     * 
     * @type {Array<TripInvalidity>}
     * @memberof Trip
     */
    invalidities?: Array<TripInvalidity>;
    /**
     * OEAMTC KFZ Vehicle Id
     * @type {number}
     * @memberof Trip
     */
    vehicleId?: number;
    /**
     * 
     * @type {Array<TripStop>}
     * @memberof Trip
     */
    stops?: Array<TripStop>;
    /**
     * Note for a trip, for example: Pick up kids from soccer
     * @type {string}
     * @memberof Trip
     */
    note?: string;
    /**
     * Trip route geometry (polyline). If creating trip and polyline is null, polyline will be calculated
     * @type {string}
     * @memberof Trip
     */
    routeGeometry?: string;
    /**
     * 
     * @type {TripSource}
     * @memberof Trip
     */
    source: TripSource;
    /**
     * Trip is a fsl (fahrschule) trip
     * @type {boolean}
     * @memberof Trip
     */
    fsl?: boolean;
    /**
     * Trip is a work trip
     * @type {boolean}
     * @memberof Trip
     */
    work?: boolean;
    /**
     * 
     * @type {ExtraData}
     * @memberof Trip
     */
    extraData?: ExtraData;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof Trip
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof Trip
     */
    updatedAt: string;
}
/**
 * OEAMTC Trip representation
 * @export
 * @interface TripAllOf
 */
export interface TripAllOf {
    /**
     * Trip id
     * @type {number}
     * @memberof TripAllOf
     */
    id: number;
    /**
     * 
     * @type {Pilot}
     * @memberof TripAllOf
     */
    pilot?: Pilot;
    /**
     * 
     * @type {Tag}
     * @memberof TripAllOf
     */
    tag?: Tag;
    /**
     * 
     * @type {TripInfo}
     * @memberof TripAllOf
     */
    startInfo: TripInfo;
    /**
     * 
     * @type {TripInfo}
     * @memberof TripAllOf
     */
    endInfo?: TripInfo;
    /**
     * collection of fuel stops made during trip or after it was finished ascendently sorted by timestamp
     * @type {Array<FuelStop>}
     * @memberof TripAllOf
     */
    fuelStops?: Array<FuelStop>;
    /**
     * Duration in milliseconds the car was parked before starting this trip
     * @type {number}
     * @memberof TripAllOf
     */
    parkingTimeBefore?: number;
    /**
     * Duration in milliseconds the car was parked after finishing this trip
     * @type {number}
     * @memberof TripAllOf
     */
    parkingTimeAfter?: number;
    /**
     * Distance travelled in metres
     * @type {number}
     * @memberof TripAllOf
     */
    distance?: number;
    /**
     * Duration of trip in milliseconds. This may be null if trip is still in progress.
     * @type {number}
     * @memberof TripAllOf
     */
    duration?: number;
    /**
     * 
     * @type {FuelInformation}
     * @memberof TripAllOf
     */
    fuelInformation?: FuelInformation;
    /**
     * 
     * @type {Array<TripChange>}
     * @memberof TripAllOf
     */
    changes?: Array<TripChange>;
    /**
     * 
     * @type {Array<TripInvalidity>}
     * @memberof TripAllOf
     */
    invalidities?: Array<TripInvalidity>;
}
/**
 * OEAMTC Trip representation which can be read and modified
 * @export
 * @interface TripBase
 */
export interface TripBase {
    /**
     * OEAMTC KFZ Vehicle Id
     * @type {number}
     * @memberof TripBase
     */
    vehicleId?: number;
    /**
     * 
     * @type {Array<TripStop>}
     * @memberof TripBase
     */
    stops?: Array<TripStop>;
    /**
     * Note for a trip, for example: Pick up kids from soccer
     * @type {string}
     * @memberof TripBase
     */
    note?: string;
    /**
     * Trip route geometry (polyline). If creating trip and polyline is null, polyline will be calculated
     * @type {string}
     * @memberof TripBase
     */
    routeGeometry?: string;
    /**
     * 
     * @type {TripSource}
     * @memberof TripBase
     */
    source: TripSource;
    /**
     * Trip is a fsl (fahrschule) trip
     * @type {boolean}
     * @memberof TripBase
     */
    fsl?: boolean;
    /**
     * Trip is a work trip
     * @type {boolean}
     * @memberof TripBase
     */
    work?: boolean;
    /**
     * 
     * @type {ExtraData}
     * @memberof TripBase
     */
    extraData?: ExtraData;
}
/**
 * Single change of a trip
 * @export
 * @interface TripChange
 */
export interface TripChange {
    /**
     * the date and time the change occured
     * @type {string}
     * @memberof TripChange
     */
    date?: string;
    /**
     * who the change had been done by e.g. Smart Connect or the user
     * @type {string}
     * @memberof TripChange
     */
    doneBy?: string;
    /**
     * the date and time the change occured
     * @type {Array<string>}
     * @memberof TripChange
     */
    descriptions?: Array<string>;
}
/**
 * 
 * @export
 * @interface TripError
 */
export interface TripError {
    /**
     * 
     * @type {Trip}
     * @memberof TripError
     */
    first?: Trip;
    /**
     * 
     * @type {Trip}
     * @memberof TripError
     */
    second?: Trip;
    /**
     * 
     * @type {ErrorType}
     * @memberof TripError
     */
    type?: ErrorType;
}
/**
 * Ids of the trips to merge. There is no ordering in the pair meaning the first and second trip are interchangeable
 * @export
 * @interface TripIdPair
 */
export interface TripIdPair {
    /**
     * 
     * @type {number}
     * @memberof TripIdPair
     */
    firstTripId: number;
    /**
     * 
     * @type {number}
     * @memberof TripIdPair
     */
    secondTripId: number;
}
/**
 * Trip info regarding start or end of trip such as address, timestamp, etc.
 * @export
 * @interface TripInfo
 */
export interface TripInfo {
    /**
     * Timestamp of trip
     * @type {string}
     * @memberof TripInfo
     */
    timestamp: string;
    /**
     * 
     * @type {Address}
     * @memberof TripInfo
     */
    address?: Address;
    /**
     * 
     * @type {Location}
     * @memberof TripInfo
     */
    location?: Location;
    /**
     * Odometer reading in metres
     * @type {number}
     * @memberof TripInfo
     */
    odometer: number;
    /**
     * 
     * @type {Zone}
     * @memberof TripInfo
     */
    zone?: Zone;
}
/**
 * 
 * @export
 * @interface TripInfoAllOf
 */
export interface TripInfoAllOf {
    /**
     * 
     * @type {Zone}
     * @memberof TripInfoAllOf
     */
    zone?: Zone;
}
/**
 * Trip info which can be modified
 * @export
 * @interface TripInfoMutation
 */
export interface TripInfoMutation {
    /**
     * Timestamp of trip
     * @type {string}
     * @memberof TripInfoMutation
     */
    timestamp: string;
    /**
     * 
     * @type {Address}
     * @memberof TripInfoMutation
     */
    address?: Address;
    /**
     * 
     * @type {Location}
     * @memberof TripInfoMutation
     */
    location?: Location;
    /**
     * Odometer reading in metres
     * @type {number}
     * @memberof TripInfoMutation
     */
    odometer: number;
}
/**
 * Type of invalidity
 * @export
 * @enum {string}
 */
export enum TripInvalidity {
    ReversedTimestamps = 'reversedTimestamps',
    ReversedOdometers = 'reversedOdometers',
    TooFast = 'tooFast',
    NegativeSpeed = 'negativeSpeed',
    TooOld = 'tooOld',
    InvalidStartCoordinates = 'invalidStartCoordinates',
    InvalidEndCoordinates = 'invalidEndCoordinates'
}

/**
 * Trip log representation. Shows whether a trip log is archived or not.
 * @export
 * @interface TripLog
 */
export interface TripLog {
    /**
     * 
     * @type {Vehicle}
     * @memberof TripLog
     */
    vehicle: Vehicle;
    /**
     * True if this log is archived and therefore unmodifiable, false otherwise
     * @type {boolean}
     * @memberof TripLog
     */
    archived: boolean;
    /**
     * True if this log is associated to a smart connect abo
     * @type {boolean}
     * @memberof TripLog
     */
    smartConnected?: boolean;
    /**
     * Odometer reading in metres
     * @type {number}
     * @memberof TripLog
     */
    odometer?: number;
    /**
     * Timestamp of last trip
     * @type {string}
     * @memberof TripLog
     */
    lastTripTimestamp?: string;
    /**
     * 
     * @type {VehicleSettings}
     * @memberof TripLog
     */
    vehicleSettings: VehicleSettings;
}
/**
 * OEAMTC Trip representation which can be modified
 * @export
 * @interface TripMutation
 */
export interface TripMutation {
    /**
     * Pilot id of pilot who drove this trip
     * @type {number}
     * @memberof TripMutation
     */
    pilotId?: number;
    /**
     * Tag id of tag associated with this trip
     * @type {number}
     * @memberof TripMutation
     */
    tagId?: number;
    /**
     * 
     * @type {TripInfoMutation}
     * @memberof TripMutation
     */
    startInfo: TripInfoMutation;
    /**
     * 
     * @type {TripInfoMutation}
     * @memberof TripMutation
     */
    endInfo?: TripInfoMutation;
    /**
     * Indicates whether route geometry should be adjusted (improved)
     * @type {boolean}
     * @memberof TripMutation
     */
    adjustRouteGeometry?: boolean;
    /**
     * OEAMTC KFZ Vehicle Id
     * @type {number}
     * @memberof TripMutation
     */
    vehicleId?: number;
    /**
     * 
     * @type {Array<TripStop>}
     * @memberof TripMutation
     */
    stops?: Array<TripStop>;
    /**
     * Note for a trip, for example: Pick up kids from soccer
     * @type {string}
     * @memberof TripMutation
     */
    note?: string;
    /**
     * Trip route geometry (polyline). If creating trip and polyline is null, polyline will be calculated
     * @type {string}
     * @memberof TripMutation
     */
    routeGeometry?: string;
    /**
     * 
     * @type {TripSource}
     * @memberof TripMutation
     */
    source: TripSource;
    /**
     * Trip is a fsl (fahrschule) trip
     * @type {boolean}
     * @memberof TripMutation
     */
    fsl?: boolean;
    /**
     * Trip is a work trip
     * @type {boolean}
     * @memberof TripMutation
     */
    work?: boolean;
    /**
     * 
     * @type {ExtraData}
     * @memberof TripMutation
     */
    extraData?: ExtraData;
}
/**
 * OEAMTC Trips relationships references
 * @export
 * @interface TripMutationAllOf
 */
export interface TripMutationAllOf {
    /**
     * Pilot id of pilot who drove this trip
     * @type {number}
     * @memberof TripMutationAllOf
     */
    pilotId?: number;
    /**
     * Tag id of tag associated with this trip
     * @type {number}
     * @memberof TripMutationAllOf
     */
    tagId?: number;
    /**
     * 
     * @type {TripInfoMutation}
     * @memberof TripMutationAllOf
     */
    startInfo: TripInfoMutation;
    /**
     * 
     * @type {TripInfoMutation}
     * @memberof TripMutationAllOf
     */
    endInfo?: TripInfoMutation;
    /**
     * Indicates whether route geometry should be adjusted (improved)
     * @type {boolean}
     * @memberof TripMutationAllOf
     */
    adjustRouteGeometry?: boolean;
}
/**
 * Source app where the trip was created
 * @export
 * @enum {string}
 */
export enum TripSource {
    CCS = 'CCS',
    MOE = 'MOE',
    FSL = 'FSL'
}

/**
 * Information regarding a trip intermediate stop. At least one of address or location required on creation
 * @export
 * @interface TripStop
 */
export interface TripStop {
    /**
     * 
     * @type {Address}
     * @memberof TripStop
     */
    address?: Address;
    /**
     * 
     * @type {Location}
     * @memberof TripStop
     */
    location?: Location;
}
/**
 * 
 * @export
 * @interface TripsPage
 */
export interface TripsPage {
    /**
     * Amount of trips in this page. Between 0 and page.limit.
     * @type {number}
     * @memberof TripsPage
     */
    count?: number;
    /**
     * Page offset
     * @type {number}
     * @memberof TripsPage
     */
    offset?: number;
    /**
     * 
     * @type {Array<Trip>}
     * @memberof TripsPage
     */
    trips?: Array<Trip>;
}
/**
 * Represents summarized information recorded from multiple trips
 * @export
 * @interface TripsSummary
 */
export interface TripsSummary {
    /**
     * Total amount of trips
     * @type {number}
     * @memberof TripsSummary
     */
    totalTrips: number;
    /**
     * Total trips distance in metres
     * @type {number}
     * @memberof TripsSummary
     */
    totalDistance: number;
    /**
     * Total trips duration in minutes
     * @type {number}
     * @memberof TripsSummary
     */
    totalDuration: number;
}
/**
 * tripCount and statistics corresponding to trips attributes. This are null when tripCount is 0, meaning no trips were recorded.
 * @export
 * @interface UncountableDiagramStatistics
 */
export interface UncountableDiagramStatistics {
    /**
     * 
     * @type {CountStatistic}
     * @memberof UncountableDiagramStatistics
     */
    tripCount: CountStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof UncountableDiagramStatistics
     */
    distance?: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof UncountableDiagramStatistics
     */
    duration?: SummableStatistic;
    /**
     * 
     * @type {Statistic}
     * @memberof UncountableDiagramStatistics
     */
    speed?: Statistic;
    /**
     * 
     * @type {Statistic}
     * @memberof UncountableDiagramStatistics
     */
    ecoScore?: Statistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof UncountableDiagramStatistics
     */
    fuelConsumption?: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof UncountableDiagramStatistics
     */
    emissions?: SummableStatistic;
    /**
     * 
     * @type {SummableStatistic}
     * @memberof UncountableDiagramStatistics
     */
    cost?: SummableStatistic;
}
/**
 * Vehicle associated with a trip log
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    brand: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    model: string;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    year?: number;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    licensePlate: string;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    setupDone?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    deviceId?: string;
}
/**
 * 
 * @export
 * @interface VehicleHealth
 */
export interface VehicleHealth {
    /**
     * 
     * @type {string}
     * @memberof VehicleHealth
     */
    aggregateState?: VehicleHealthAggregateStateEnum;
    /**
     * 
     * @type {Array<MaintenanceItemHealth>}
     * @memberof VehicleHealth
     */
    maintainanceItems?: Array<MaintenanceItemHealth>;
    /**
     * Number of issues influencing the aggregateState
     * @type {number}
     * @memberof VehicleHealth
     */
    numIssues?: number;
    /**
     * 
     * @type {CarHealthDetail}
     * @memberof VehicleHealth
     */
    carHealthDetails?: CarHealthDetail;
    /**
     * Percentage of fuel level
     * @type {number}
     * @memberof VehicleHealth
     */
    lastFuelLevel?: number;
    /**
     * Odometer in meters
     * @type {number}
     * @memberof VehicleHealth
     */
    odometer?: number;
    /**
     * 
     * @type {Array<DTC>}
     * @memberof VehicleHealth
     */
    dtcs?: Array<DTC>;
}

/**
    * @export
    * @enum {string}
    */
export enum VehicleHealthAggregateStateEnum {
    UNPLUGGED = 'UNPLUGGED',
    RED = 'RED',
    YELLOW = 'YELLOW',
    GREEN = 'GREEN'
}

/**
 * 
 * @export
 * @interface VehicleSeedOdometerUpdate
 */
export interface VehicleSeedOdometerUpdate {
    /**
     * 
     * @type {number}
     * @memberof VehicleSeedOdometerUpdate
     */
    seedOdometer: number;
}
/**
 * 
 * @export
 * @interface VehicleSeedOdometerUpdateRequest
 */
export interface VehicleSeedOdometerUpdateRequest {
    /**
     * 
     * @type {VehicleSeedOdometerUpdate}
     * @memberof VehicleSeedOdometerUpdateRequest
     */
    data: VehicleSeedOdometerUpdate;
}
/**
 * Settings for a particular vehicle
 * @export
 * @interface VehicleSettings
 */
export interface VehicleSettings {
    /**
     * 
     * @type {FuelConsumptionType}
     * @memberof VehicleSettings
     */
    fuelConsumptionType?: FuelConsumptionType;
    /**
     * 
     * @type {FuelUnit}
     * @memberof VehicleSettings
     */
    fuelUnit: FuelUnit;
    /**
     * 
     * @type {number}
     * @memberof VehicleSettings
     */
    fuelCapacity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSettings
     */
    fuelStopSuggestions: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleSettings
     */
    mergeBreakThreshold?: string;
}
/**
 * 
 * @export
 * @interface Week
 */
export interface Week {
    /**
     * 
     * @type {number}
     * @memberof Week
     */
    weekOfYear: number;
    /**
     * 
     * @type {number}
     * @memberof Week
     */
    year: number;
}
/**
 * 
 * @export
 * @interface Weekday
 */
export interface Weekday {
    /**
     * 
     * @type {string}
     * @memberof Weekday
     */
    name?: WeekdayNameEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WeekdayNameEnum {
    Monday = 'monday',
    Tuesday = 'tuesday',
    Wednesday = 'wednesday',
    Thursday = 'thursday',
    Friday = 'friday',
    Saturday = 'saturday',
    Sunday = 'sunday'
}

/**
 * 
 * @export
 * @interface WeekdayStatistics
 */
export interface WeekdayStatistics {
    /**
     * 
     * @type {Weekday}
     * @memberof WeekdayStatistics
     */
    weekday: Weekday;
    /**
     * 
     * @type {CountableDiagramStatistics}
     * @memberof WeekdayStatistics
     */
    statistics: CountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface WeeklyStatistics
 */
export interface WeeklyStatistics {
    /**
     * 
     * @type {Week}
     * @memberof WeeklyStatistics
     */
    week: Week;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof WeeklyStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * 
 * @export
 * @interface YearlyStatistics
 */
export interface YearlyStatistics {
    /**
     * 
     * @type {number}
     * @memberof YearlyStatistics
     */
    year: number;
    /**
     * 
     * @type {UncountableDiagramStatistics}
     * @memberof YearlyStatistics
     */
    statistics: UncountableDiagramStatistics;
}
/**
 * Zone representation. Trips start or end at particular, user defined zones.
 * @export
 * @interface Zone
 */
export interface Zone {
    /**
     * Tag id
     * @type {number}
     * @memberof Zone
     */
    id: number;
    /**
     * 
     * @type {Address}
     * @memberof Zone
     */
    address?: Address;
    /**
     * Whether the zone is synchronized with GIS Favorites
     * @type {boolean}
     * @memberof Zone
     */
    synchronizedWithGisFavorite?: boolean;
    /**
     * Zone name
     * @type {string}
     * @memberof Zone
     */
    name: string;
    /**
     * Latitude of the location
     * @type {number}
     * @memberof Zone
     */
    latitude: number;
    /**
     * Longitude of the location
     * @type {number}
     * @memberof Zone
     */
    longitude: number;
    /**
     * Radius around the cooridnates of the UserPOI
     * @type {number}
     * @memberof Zone
     */
    radius: number;
    /**
     * Whether to send short parking zone notification when trip ends inside this zone and short parking zone
     * @type {boolean}
     * @memberof Zone
     */
    shortParkingZoneNotification?: boolean;
    /**
     * Timestamp when this resource was created
     * @type {string}
     * @memberof Zone
     */
    createdAt: string;
    /**
     * Timestamp when this resource was last updated
     * @type {string}
     * @memberof Zone
     */
    updatedAt: string;
}
/**
 * 
 * @export
 * @interface ZoneAllOf
 */
export interface ZoneAllOf {
    /**
     * Tag id
     * @type {number}
     * @memberof ZoneAllOf
     */
    id: number;
    /**
     * 
     * @type {Address}
     * @memberof ZoneAllOf
     */
    address?: Address;
    /**
     * Whether the zone is synchronized with GIS Favorites
     * @type {boolean}
     * @memberof ZoneAllOf
     */
    synchronizedWithGisFavorite?: boolean;
}
/**
 * 
 * @export
 * @interface ZoneHighlight
 */
export interface ZoneHighlight {
    /**
     * 
     * @type {number}
     * @memberof ZoneHighlight
     */
    count: number;
    /**
     * 
     * @type {Zone}
     * @memberof ZoneHighlight
     */
    zone: Zone;
}
/**
 * Zone mutation properties representation
 * @export
 * @interface ZoneMutation
 */
export interface ZoneMutation {
    /**
     * Zone name
     * @type {string}
     * @memberof ZoneMutation
     */
    name: string;
    /**
     * Latitude of the location
     * @type {number}
     * @memberof ZoneMutation
     */
    latitude: number;
    /**
     * Longitude of the location
     * @type {number}
     * @memberof ZoneMutation
     */
    longitude: number;
    /**
     * Radius around the cooridnates of the UserPOI
     * @type {number}
     * @memberof ZoneMutation
     */
    radius: number;
    /**
     * Whether to send short parking zone notification when trip ends inside this zone and short parking zone
     * @type {boolean}
     * @memberof ZoneMutation
     */
    shortParkingZoneNotification?: boolean;
}
/**
 * 
 * @export
 * @interface ZoneSuggestion
 */
export interface ZoneSuggestion {
    /**
     * 
     * @type {Address}
     * @memberof ZoneSuggestion
     */
    address: Address;
    /**
     * Zone name
     * @type {string}
     * @memberof ZoneSuggestion
     */
    name: string;
    /**
     * Latitude of the location
     * @type {number}
     * @memberof ZoneSuggestion
     */
    latitude: number;
    /**
     * Longitude of the location
     * @type {number}
     * @memberof ZoneSuggestion
     */
    longitude: number;
    /**
     * Radius around the cooridnates of the UserPOI
     * @type {number}
     * @memberof ZoneSuggestion
     */
    radius: number;
    /**
     * Whether to send short parking zone notification when trip ends inside this zone and short parking zone
     * @type {boolean}
     * @memberof ZoneSuggestion
     */
    shortParkingZoneNotification?: boolean;
}
/**
 * 
 * @export
 * @interface ZoneSuggestionAllOf
 */
export interface ZoneSuggestionAllOf {
    /**
     * 
     * @type {Address}
     * @memberof ZoneSuggestionAllOf
     */
    address: Address;
}
/**
 * 
 * @export
 * @interface ZoneSuggestions
 */
export interface ZoneSuggestions {
    /**
     * 
     * @type {Array<ZoneSuggestion>}
     * @memberof ZoneSuggestions
     */
    house: Array<ZoneSuggestion>;
    /**
     * 
     * @type {Array<ZoneSuggestion>}
     * @memberof ZoneSuggestions
     */
    work: Array<ZoneSuggestion>;
}

/**
 * DeviceApi - axios parameter creator
 * @export
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: async (deviceId: string, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId','Required parameter deviceId was null or undefined when calling getDevice.');
            }
            const localVarPath = `/devices/{deviceId}/serial`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullDevice: async (deviceId: string, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId','Required parameter deviceId was null or undefined when calling getFullDevice.');
            }
            const localVarPath = `/devices/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 * @export
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevice(deviceId: string, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceInfo>> {
            const localVarAxiosArgs = await DeviceApiAxiosParamCreator(configuration).getDevice(deviceId, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFullDevice(deviceId: string, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Device>> {
            const localVarAxiosArgs = await DeviceApiAxiosParamCreator(configuration).getFullDevice(deviceId, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DeviceApi - factory interface
 * @export
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice(deviceId: string, oeamtcIdentityKey?: string, options?: any): AxiosPromise<DeviceInfo> {
            return DeviceApiFp(configuration).getDevice(deviceId, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullDevice(deviceId: string, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Device> {
            return DeviceApiFp(configuration).getFullDevice(deviceId, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
export class DeviceApi extends BaseAPI {
    /**
     * 
     * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public getDevice(deviceId: string, oeamtcIdentityKey?: string, options?: any) {
        return DeviceApiFp(this.configuration).getDevice(deviceId, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceId The Device Id - needs to be a valid UUID (RFC 4122)
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public getFullDevice(deviceId: string, oeamtcIdentityKey?: string, options?: any) {
        return DeviceApiFp(this.configuration).getFullDevice(deviceId, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * DirectedRouteApi - axios parameter creator
 * @export
 */
export const DirectedRouteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the directed routes owned by the user. These are generated by trips which present a start and end zone
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectedRoutes: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/directedroutes`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DirectedRouteApi - functional programming interface
 * @export
 */
export const DirectedRouteApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the directed routes owned by the user. These are generated by trips which present a start and end zone
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectedRoutes(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DirectedRoute>>> {
            const localVarAxiosArgs = await DirectedRouteApiAxiosParamCreator(configuration).getDirectedRoutes(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DirectedRouteApi - factory interface
 * @export
 */
export const DirectedRouteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns the directed routes owned by the user. These are generated by trips which present a start and end zone
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectedRoutes(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<DirectedRoute>> {
            return DirectedRouteApiFp(configuration).getDirectedRoutes(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DirectedRouteApi - object-oriented interface
 * @export
 * @class DirectedRouteApi
 * @extends {BaseAPI}
 */
export class DirectedRouteApi extends BaseAPI {
    /**
     * 
     * @summary Returns the directed routes owned by the user. These are generated by trips which present a start and end zone
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectedRouteApi
     */
    public getDirectedRoutes(oeamtcIdentityKey?: string, options?: any) {
        return DirectedRouteApiFp(this.configuration).getDirectedRoutes(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EcoScoreApi - axios parameter creator
 * @export
 */
export const EcoScoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a driving recommendation based on the trip\'s eco score
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcoScoreRecommendation: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEcoScoreRecommendation.');
            }
            const localVarPath = `/trips/{id}/ecoScoreRecommendation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EcoScoreApi - functional programming interface
 * @export
 */
export const EcoScoreApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a driving recommendation based on the trip\'s eco score
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcoScoreRecommendation(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcoScoreRecommendation>> {
            const localVarAxiosArgs = await EcoScoreApiAxiosParamCreator(configuration).getEcoScoreRecommendation(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EcoScoreApi - factory interface
 * @export
 */
export const EcoScoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns a driving recommendation based on the trip\'s eco score
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcoScoreRecommendation(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<EcoScoreRecommendation> {
            return EcoScoreApiFp(configuration).getEcoScoreRecommendation(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EcoScoreApi - object-oriented interface
 * @export
 * @class EcoScoreApi
 * @extends {BaseAPI}
 */
export class EcoScoreApi extends BaseAPI {
    /**
     * 
     * @summary Returns a driving recommendation based on the trip\'s eco score
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EcoScoreApi
     */
    public getEcoScoreRecommendation(id: number, oeamtcIdentityKey?: string, options?: any) {
        return EcoScoreApiFp(this.configuration).getEcoScoreRecommendation(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExportApi - axios parameter creator
 * @export
 */
export const ExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * send email to the user with health report built between the given date ranges. Only allowed for smart connect users
         * @summary send email with health report
         * @param {ExportHealthBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportHealth: async (exportData: ExportHealthBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportData' is not null or undefined
            if (exportData === null || exportData === undefined) {
                throw new RequiredError('exportData','Required parameter exportData was null or undefined when calling exportHealth.');
            }
            const localVarPath = `/health/export`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof exportData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(exportData !== undefined ? exportData : {}) : (exportData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
         * @summary send email with exported trips in the desired format
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {ExportBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTrips: async (vehicleId: number, exportData: ExportBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling exportTrips.');
            }
            // verify required parameter 'exportData' is not null or undefined
            if (exportData === null || exportData === undefined) {
                throw new RequiredError('exportData','Required parameter exportData was null or undefined when calling exportTrips.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips/export`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof exportData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(exportData !== undefined ? exportData : {}) : (exportData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
         * @summary send email with exported trips in the desired format
         * @param {ExportBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTripsSkipVehicleId: async (exportData: ExportBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportData' is not null or undefined
            if (exportData === null || exportData === undefined) {
                throw new RequiredError('exportData','Required parameter exportData was null or undefined when calling exportTripsSkipVehicleId.');
            }
            const localVarPath = `/trips/export`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof exportData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(exportData !== undefined ? exportData : {}) : (exportData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportApi - functional programming interface
 * @export
 */
export const ExportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * send email to the user with health report built between the given date ranges. Only allowed for smart connect users
         * @summary send email with health report
         * @param {ExportHealthBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportHealth(exportData: ExportHealthBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExportApiAxiosParamCreator(configuration).exportHealth(exportData, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
         * @summary send email with exported trips in the desired format
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {ExportBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTrips(vehicleId: number, exportData: ExportBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExportApiAxiosParamCreator(configuration).exportTrips(vehicleId, exportData, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
         * @summary send email with exported trips in the desired format
         * @param {ExportBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTripsSkipVehicleId(exportData: ExportBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExportApiAxiosParamCreator(configuration).exportTripsSkipVehicleId(exportData, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExportApi - factory interface
 * @export
 */
export const ExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * send email to the user with health report built between the given date ranges. Only allowed for smart connect users
         * @summary send email with health report
         * @param {ExportHealthBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportHealth(exportData: ExportHealthBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return ExportApiFp(configuration).exportHealth(exportData, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
         * @summary send email with exported trips in the desired format
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {ExportBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTrips(vehicleId: number, exportData: ExportBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return ExportApiFp(configuration).exportTrips(vehicleId, exportData, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
         * @summary send email with exported trips in the desired format
         * @param {ExportBody} exportData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTripsSkipVehicleId(exportData: ExportBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return ExportApiFp(configuration).exportTripsSkipVehicleId(exportData, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
export class ExportApi extends BaseAPI {
    /**
     * send email to the user with health report built between the given date ranges. Only allowed for smart connect users
     * @summary send email with health report
     * @param {ExportHealthBody} exportData The user email and export filters
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public exportHealth(exportData: ExportHealthBody, oeamtcIdentityKey?: string, options?: any) {
        return ExportApiFp(this.configuration).exportHealth(exportData, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
     * @summary send email with exported trips in the desired format
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {ExportBody} exportData The user email and export filters
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public exportTrips(vehicleId: number, exportData: ExportBody, oeamtcIdentityKey?: string, options?: any) {
        return ExportApiFp(this.configuration).exportTrips(vehicleId, exportData, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * send email to the abonnement user with the trips exported in the desired format and date ranges. Filters for tags and pilots supported.
     * @summary send email with exported trips in the desired format
     * @param {ExportBody} exportData The user email and export filters
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportApi
     */
    public exportTripsSkipVehicleId(exportData: ExportBody, oeamtcIdentityKey?: string, options?: any) {
        return ExportApiFp(this.configuration).exportTripsSkipVehicleId(exportData, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FuelStopApi - axios parameter creator
 * @export
 */
export const FuelStopApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelStopMutation} fuelStopCreateBody The fuel stop to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFuelStop: async (vehicleId: number, fuelStopCreateBody: FuelStopMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling createFuelStop.');
            }
            // verify required parameter 'fuelStopCreateBody' is not null or undefined
            if (fuelStopCreateBody === null || fuelStopCreateBody === undefined) {
                throw new RequiredError('fuelStopCreateBody','Required parameter fuelStopCreateBody was null or undefined when calling createFuelStop.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelstops`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fuelStopCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fuelStopCreateBody !== undefined ? fuelStopCreateBody : {}) : (fuelStopCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFuelStop: async (vehicleId: number, id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling deleteFuelStop.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteFuelStop.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelstops/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelStop: async (vehicleId: number, id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getFuelStop.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getFuelStop.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelstops/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get suggested fuel stops
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return suggested fuel stops before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return suggested fuel stops after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedFuelStops: async (vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getSuggestedFuelStops.');
            }
            const localVarPath = `/vehicles/{vehicleId}/suggested-fuelstops`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add suggested fuel stop to hidden list
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TimestampRequestBody} timestamp Hide static suggested fuel stop for given date-time permanently. If null, hide sticky suggestion for 30 days
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideSuggestedFuelStop: async (vehicleId: number, timestamp: TimestampRequestBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling hideSuggestedFuelStop.');
            }
            // verify required parameter 'timestamp' is not null or undefined
            if (timestamp === null || timestamp === undefined) {
                throw new RequiredError('timestamp','Required parameter timestamp was null or undefined when calling hideSuggestedFuelStop.');
            }
            const localVarPath = `/vehicles/{vehicleId}/suggested-fuelstops/denial`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof timestamp !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(timestamp !== undefined ? timestamp : {}) : (timestamp || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove all suggested fuel stops from hidden list
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showAllSuggestedFuelStops: async (vehicleId: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling showAllSuggestedFuelStops.');
            }
            const localVarPath = `/vehicles/{vehicleId}/suggested-fuelstops/denials`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {FuelStopMutation} fuelStopUpdateBody The updated fuel stop
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFuelStop: async (vehicleId: number, id: number, fuelStopUpdateBody: FuelStopMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling updateFuelStop.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateFuelStop.');
            }
            // verify required parameter 'fuelStopUpdateBody' is not null or undefined
            if (fuelStopUpdateBody === null || fuelStopUpdateBody === undefined) {
                throw new RequiredError('fuelStopUpdateBody','Required parameter fuelStopUpdateBody was null or undefined when calling updateFuelStop.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelstops/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fuelStopUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fuelStopUpdateBody !== undefined ? fuelStopUpdateBody : {}) : (fuelStopUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FuelStopApi - functional programming interface
 * @export
 */
export const FuelStopApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelStopMutation} fuelStopCreateBody The fuel stop to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFuelStop(vehicleId: number, fuelStopCreateBody: FuelStopMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelStop>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).createFuelStop(vehicleId, fuelStopCreateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFuelStop(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).deleteFuelStop(vehicleId, id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFuelStop(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelStop>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).getFuelStop(vehicleId, id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get suggested fuel stops
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return suggested fuel stops before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return suggested fuel stops after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestedFuelStops(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuggestedFuelStop>>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).getSuggestedFuelStops(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Add suggested fuel stop to hidden list
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TimestampRequestBody} timestamp Hide static suggested fuel stop for given date-time permanently. If null, hide sticky suggestion for 30 days
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideSuggestedFuelStop(vehicleId: number, timestamp: TimestampRequestBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).hideSuggestedFuelStop(vehicleId, timestamp, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove all suggested fuel stops from hidden list
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showAllSuggestedFuelStops(vehicleId: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).showAllSuggestedFuelStops(vehicleId, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {FuelStopMutation} fuelStopUpdateBody The updated fuel stop
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFuelStop(vehicleId: number, id: number, fuelStopUpdateBody: FuelStopMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelStop>> {
            const localVarAxiosArgs = await FuelStopApiAxiosParamCreator(configuration).updateFuelStop(vehicleId, id, fuelStopUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FuelStopApi - factory interface
 * @export
 */
export const FuelStopApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelStopMutation} fuelStopCreateBody The fuel stop to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFuelStop(vehicleId: number, fuelStopCreateBody: FuelStopMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<FuelStop> {
            return FuelStopApiFp(configuration).createFuelStop(vehicleId, fuelStopCreateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFuelStop(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return FuelStopApiFp(configuration).deleteFuelStop(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelStop(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<FuelStop> {
            return FuelStopApiFp(configuration).getFuelStop(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get suggested fuel stops
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return suggested fuel stops before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return suggested fuel stops after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedFuelStops(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options?: any): AxiosPromise<Array<SuggestedFuelStop>> {
            return FuelStopApiFp(configuration).getSuggestedFuelStops(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add suggested fuel stop to hidden list
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TimestampRequestBody} timestamp Hide static suggested fuel stop for given date-time permanently. If null, hide sticky suggestion for 30 days
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideSuggestedFuelStop(vehicleId: number, timestamp: TimestampRequestBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return FuelStopApiFp(configuration).hideSuggestedFuelStop(vehicleId, timestamp, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove all suggested fuel stops from hidden list
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showAllSuggestedFuelStops(vehicleId: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return FuelStopApiFp(configuration).showAllSuggestedFuelStops(vehicleId, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a fuel stop
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {FuelStopMutation} fuelStopUpdateBody The updated fuel stop
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFuelStop(vehicleId: number, id: number, fuelStopUpdateBody: FuelStopMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<FuelStop> {
            return FuelStopApiFp(configuration).updateFuelStop(vehicleId, id, fuelStopUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FuelStopApi - object-oriented interface
 * @export
 * @class FuelStopApi
 * @extends {BaseAPI}
 */
export class FuelStopApi extends BaseAPI {
    /**
     * 
     * @summary Create a fuel stop
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {FuelStopMutation} fuelStopCreateBody The fuel stop to be created
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public createFuelStop(vehicleId: number, fuelStopCreateBody: FuelStopMutation, oeamtcIdentityKey?: string, options?: any) {
        return FuelStopApiFp(this.configuration).createFuelStop(vehicleId, fuelStopCreateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a fuel stop
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public deleteFuelStop(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any) {
        return FuelStopApiFp(this.configuration).deleteFuelStop(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a fuel stop
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public getFuelStop(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any) {
        return FuelStopApiFp(this.configuration).getFuelStop(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get suggested fuel stops
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {string} [filterFrom] do not return suggested fuel stops before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return suggested fuel stops after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public getSuggestedFuelStops(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options?: any) {
        return FuelStopApiFp(this.configuration).getSuggestedFuelStops(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add suggested fuel stop to hidden list
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {TimestampRequestBody} timestamp Hide static suggested fuel stop for given date-time permanently. If null, hide sticky suggestion for 30 days
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public hideSuggestedFuelStop(vehicleId: number, timestamp: TimestampRequestBody, oeamtcIdentityKey?: string, options?: any) {
        return FuelStopApiFp(this.configuration).hideSuggestedFuelStop(vehicleId, timestamp, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove all suggested fuel stops from hidden list
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public showAllSuggestedFuelStops(vehicleId: number, oeamtcIdentityKey?: string, options?: any) {
        return FuelStopApiFp(this.configuration).showAllSuggestedFuelStops(vehicleId, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a fuel stop
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {FuelStopMutation} fuelStopUpdateBody The updated fuel stop
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelStopApi
     */
    public updateFuelStop(vehicleId: number, id: number, fuelStopUpdateBody: FuelStopMutation, oeamtcIdentityKey?: string, options?: any) {
        return FuelStopApiFp(this.configuration).updateFuelStop(vehicleId, id, fuelStopUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * When the user fulfilled a maintainenceItem associated with one of his vehicles, this request is used to mark the maintenanceItem as checked
         * @summary Marks the maintenanceItems specified by the maintenanceItemId as checked
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} maintenanceItemId The maintenanceItem\&#39;s id
         * @param {MaintenanceItemUpdateBody} maintenanceItemUpdateRequestBody The maintenanceItem properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMaintenanceItem: async (vehicleId: number, maintenanceItemId: string, maintenanceItemUpdateRequestBody: MaintenanceItemUpdateBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling checkMaintenanceItem.');
            }
            // verify required parameter 'maintenanceItemId' is not null or undefined
            if (maintenanceItemId === null || maintenanceItemId === undefined) {
                throw new RequiredError('maintenanceItemId','Required parameter maintenanceItemId was null or undefined when calling checkMaintenanceItem.');
            }
            // verify required parameter 'maintenanceItemUpdateRequestBody' is not null or undefined
            if (maintenanceItemUpdateRequestBody === null || maintenanceItemUpdateRequestBody === undefined) {
                throw new RequiredError('maintenanceItemUpdateRequestBody','Required parameter maintenanceItemUpdateRequestBody was null or undefined when calling checkMaintenanceItem.');
            }
            const localVarPath = `/vehicles/{vehicleId}/health/maintenanceItems/{maintenanceItemId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"maintenanceItemId"}}`, encodeURIComponent(String(maintenanceItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof maintenanceItemUpdateRequestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(maintenanceItemUpdateRequestBody !== undefined ? maintenanceItemUpdateRequestBody : {}) : (maintenanceItemUpdateRequestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data on a specific vehicle\'s health, including recommended maintainance items and current DTCs
         * @summary Returns information about a vehicle\'s health
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleHealth: async (vehicleId: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehicleHealth.');
            }
            const localVarPath = `/vehicles/{vehicleId}/health`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    return {
        /**
         * When the user fulfilled a maintainenceItem associated with one of his vehicles, this request is used to mark the maintenanceItem as checked
         * @summary Marks the maintenanceItems specified by the maintenanceItemId as checked
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} maintenanceItemId The maintenanceItem\&#39;s id
         * @param {MaintenanceItemUpdateBody} maintenanceItemUpdateRequestBody The maintenanceItem properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMaintenanceItem(vehicleId: number, maintenanceItemId: string, maintenanceItemUpdateRequestBody: MaintenanceItemUpdateBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await HealthApiAxiosParamCreator(configuration).checkMaintenanceItem(vehicleId, maintenanceItemId, maintenanceItemUpdateRequestBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns data on a specific vehicle\'s health, including recommended maintainance items and current DTCs
         * @summary Returns information about a vehicle\'s health
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicleHealth(vehicleId: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleHealth>> {
            const localVarAxiosArgs = await HealthApiAxiosParamCreator(configuration).getVehicleHealth(vehicleId, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * When the user fulfilled a maintainenceItem associated with one of his vehicles, this request is used to mark the maintenanceItem as checked
         * @summary Marks the maintenanceItems specified by the maintenanceItemId as checked
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} maintenanceItemId The maintenanceItem\&#39;s id
         * @param {MaintenanceItemUpdateBody} maintenanceItemUpdateRequestBody The maintenanceItem properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMaintenanceItem(vehicleId: number, maintenanceItemId: string, maintenanceItemUpdateRequestBody: MaintenanceItemUpdateBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return HealthApiFp(configuration).checkMaintenanceItem(vehicleId, maintenanceItemId, maintenanceItemUpdateRequestBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data on a specific vehicle\'s health, including recommended maintainance items and current DTCs
         * @summary Returns information about a vehicle\'s health
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleHealth(vehicleId: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<VehicleHealth> {
            return HealthApiFp(configuration).getVehicleHealth(vehicleId, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * When the user fulfilled a maintainenceItem associated with one of his vehicles, this request is used to mark the maintenanceItem as checked
     * @summary Marks the maintenanceItems specified by the maintenanceItemId as checked
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} maintenanceItemId The maintenanceItem\&#39;s id
     * @param {MaintenanceItemUpdateBody} maintenanceItemUpdateRequestBody The maintenanceItem properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public checkMaintenanceItem(vehicleId: number, maintenanceItemId: string, maintenanceItemUpdateRequestBody: MaintenanceItemUpdateBody, oeamtcIdentityKey?: string, options?: any) {
        return HealthApiFp(this.configuration).checkMaintenanceItem(vehicleId, maintenanceItemId, maintenanceItemUpdateRequestBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data on a specific vehicle\'s health, including recommended maintainance items and current DTCs
     * @summary Returns information about a vehicle\'s health
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public getVehicleHealth(vehicleId: number, oeamtcIdentityKey?: string, options?: any) {
        return HealthApiFp(this.configuration).getVehicleHealth(vehicleId, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ImportApi - axios parameter creator
 * @export
 */
export const ImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Parse a list of trips in csv format and update the trips in the db accordingly.
         * @summary import trips from csv format
         * @param {ImportBody} importData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTrips: async (importData: ImportBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'importData' is not null or undefined
            if (importData === null || importData === undefined) {
                throw new RequiredError('importData','Required parameter importData was null or undefined when calling importTrips.');
            }
            const localVarPath = `/trips/import`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof importData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(importData !== undefined ? importData : {}) : (importData || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportApi - functional programming interface
 * @export
 */
export const ImportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Parse a list of trips in csv format and update the trips in the db accordingly.
         * @summary import trips from csv format
         * @param {ImportBody} importData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTrips(importData: ImportBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ImportApiAxiosParamCreator(configuration).importTrips(importData, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ImportApi - factory interface
 * @export
 */
export const ImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Parse a list of trips in csv format and update the trips in the db accordingly.
         * @summary import trips from csv format
         * @param {ImportBody} importData The user email and export filters
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTrips(importData: ImportBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return ImportApiFp(configuration).importTrips(importData, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportApi - object-oriented interface
 * @export
 * @class ImportApi
 * @extends {BaseAPI}
 */
export class ImportApi extends BaseAPI {
    /**
     * Parse a list of trips in csv format and update the trips in the db accordingly.
     * @summary import trips from csv format
     * @param {ImportBody} importData The user email and export filters
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    public importTrips(importData: ImportBody, oeamtcIdentityKey?: string, options?: any) {
        return ImportApiFp(this.configuration).importTrips(importData, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MaintenanceItemApi - axios parameter creator
 * @export
 */
export const MaintenanceItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {MaintenanceItemMutation} request The maintenance item to create
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceItems: async (vehicleId: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling createMaintenanceItems.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling createMaintenanceItems.');
            }
            const localVarPath = `/vehicles/{vehicleId}/maintenanceitems`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaintenanceItem: async (vehicleId: number, id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling deleteMaintenanceItem.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteMaintenanceItem.');
            }
            const localVarPath = `/vehicles/{vehicleId}/maintenanceitems/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceItems: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/maintenanceitems`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {MaintenanceItemActive} request The maintenance item to update active flag
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceItemActive: async (vehicleId: number, id: number, request: MaintenanceItemActive, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling updateMaintenanceItemActive.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateMaintenanceItemActive.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling updateMaintenanceItemActive.');
            }
            const localVarPath = `/vehicles/{vehicleId}/maintenanceitems/{id}/active`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {MaintenanceItemMutation} request The maintenance item to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceItems: async (vehicleId: number, id: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling updateMaintenanceItems.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateMaintenanceItems.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling updateMaintenanceItems.');
            }
            const localVarPath = `/vehicles/{vehicleId}/maintenanceitems/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceItemApi - functional programming interface
 * @export
 */
export const MaintenanceItemApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {MaintenanceItemMutation} request The maintenance item to create
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaintenanceItems(vehicleId: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MaintenanceItemApiAxiosParamCreator(configuration).createMaintenanceItems(vehicleId, request, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMaintenanceItem(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MaintenanceItemApiAxiosParamCreator(configuration).deleteMaintenanceItem(vehicleId, id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenanceItems(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MaintenanceItem>>> {
            const localVarAxiosArgs = await MaintenanceItemApiAxiosParamCreator(configuration).getMaintenanceItems(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {MaintenanceItemActive} request The maintenance item to update active flag
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaintenanceItemActive(vehicleId: number, id: number, request: MaintenanceItemActive, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MaintenanceItemApiAxiosParamCreator(configuration).updateMaintenanceItemActive(vehicleId, id, request, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {MaintenanceItemMutation} request The maintenance item to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaintenanceItems(vehicleId: number, id: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MaintenanceItemApiAxiosParamCreator(configuration).updateMaintenanceItems(vehicleId, id, request, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MaintenanceItemApi - factory interface
 * @export
 */
export const MaintenanceItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {MaintenanceItemMutation} request The maintenance item to create
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceItems(vehicleId: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return MaintenanceItemApiFp(configuration).createMaintenanceItems(vehicleId, request, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaintenanceItem(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return MaintenanceItemApiFp(configuration).deleteMaintenanceItem(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceItems(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<MaintenanceItem>> {
            return MaintenanceItemApiFp(configuration).getMaintenanceItems(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {MaintenanceItemActive} request The maintenance item to update active flag
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceItemActive(vehicleId: number, id: number, request: MaintenanceItemActive, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return MaintenanceItemApiFp(configuration).updateMaintenanceItemActive(vehicleId, id, request, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {MaintenanceItemMutation} request The maintenance item to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceItems(vehicleId: number, id: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return MaintenanceItemApiFp(configuration).updateMaintenanceItems(vehicleId, id, request, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceItemApi - object-oriented interface
 * @export
 * @class MaintenanceItemApi
 * @extends {BaseAPI}
 */
export class MaintenanceItemApi extends BaseAPI {
    /**
     * 
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {MaintenanceItemMutation} request The maintenance item to create
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceItemApi
     */
    public createMaintenanceItems(vehicleId: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options?: any) {
        return MaintenanceItemApiFp(this.configuration).createMaintenanceItems(vehicleId, request, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceItemApi
     */
    public deleteMaintenanceItem(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any) {
        return MaintenanceItemApiFp(this.configuration).deleteMaintenanceItem(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceItemApi
     */
    public getMaintenanceItems(oeamtcIdentityKey?: string, options?: any) {
        return MaintenanceItemApiFp(this.configuration).getMaintenanceItems(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {MaintenanceItemActive} request The maintenance item to update active flag
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceItemApi
     */
    public updateMaintenanceItemActive(vehicleId: number, id: number, request: MaintenanceItemActive, oeamtcIdentityKey?: string, options?: any) {
        return MaintenanceItemApiFp(this.configuration).updateMaintenanceItemActive(vehicleId, id, request, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {MaintenanceItemMutation} request The maintenance item to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceItemApi
     */
    public updateMaintenanceItems(vehicleId: number, id: number, request: MaintenanceItemMutation, oeamtcIdentityKey?: string, options?: any) {
        return MaintenanceItemApiFp(this.configuration).updateMaintenanceItems(vehicleId, id, request, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary set the active flag fro a specific notification event and vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {NotificationVehicleActiveUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVehicleNotificationActive: async (vehicleId: number, requestBody: NotificationVehicleActiveUpdateRequest, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling changeVehicleNotificationActive.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling changeVehicleNotificationActive.');
            }
            const localVarPath = `/vehicles/{vehicleId}/notifications/active`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set the channels for a specific notification event for a specific vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {NotificationVehicleUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVehicleNotifications: async (vehicleId: number, requestBody: NotificationVehicleUpdateRequest, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling changeVehicleNotifications.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling changeVehicleNotifications.');
            }
            const localVarPath = `/vehicles/{vehicleId}/notifications`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the available notification channels for a user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableNotificationChannels: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/channels/available`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the possible notification events with their activated channels for a specific vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleNotifications: async (vehicleId: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getVehicleNotifications.');
            }
            const localVarPath = `/vehicles/{vehicleId}/notifications`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary set the active flag fro a specific notification event and vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {NotificationVehicleActiveUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeVehicleNotificationActive(vehicleId: number, requestBody: NotificationVehicleActiveUpdateRequest, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).changeVehicleNotificationActive(vehicleId, requestBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary set the channels for a specific notification event for a specific vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {NotificationVehicleUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeVehicleNotifications(vehicleId: number, requestBody: NotificationVehicleUpdateRequest, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).changeVehicleNotifications(vehicleId, requestBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get the available notification channels for a user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableNotificationChannels(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationChannelEnum>>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).getAvailableNotificationChannels(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get the possible notification events with their activated channels for a specific vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicleNotifications(vehicleId: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationDataResponse>> {
            const localVarAxiosArgs = await NotificationsApiAxiosParamCreator(configuration).getVehicleNotifications(vehicleId, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary set the active flag fro a specific notification event and vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {NotificationVehicleActiveUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVehicleNotificationActive(vehicleId: number, requestBody: NotificationVehicleActiveUpdateRequest, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return NotificationsApiFp(configuration).changeVehicleNotificationActive(vehicleId, requestBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set the channels for a specific notification event for a specific vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {NotificationVehicleUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVehicleNotifications(vehicleId: number, requestBody: NotificationVehicleUpdateRequest, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return NotificationsApiFp(configuration).changeVehicleNotifications(vehicleId, requestBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the available notification channels for a user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableNotificationChannels(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<NotificationChannelEnum>> {
            return NotificationsApiFp(configuration).getAvailableNotificationChannels(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the possible notification events with their activated channels for a specific vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleNotifications(vehicleId: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<NotificationDataResponse> {
            return NotificationsApiFp(configuration).getVehicleNotifications(vehicleId, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary set the active flag fro a specific notification event and vehicle
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {NotificationVehicleActiveUpdateRequest} requestBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public changeVehicleNotificationActive(vehicleId: number, requestBody: NotificationVehicleActiveUpdateRequest, oeamtcIdentityKey?: string, options?: any) {
        return NotificationsApiFp(this.configuration).changeVehicleNotificationActive(vehicleId, requestBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set the channels for a specific notification event for a specific vehicle
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {NotificationVehicleUpdateRequest} requestBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public changeVehicleNotifications(vehicleId: number, requestBody: NotificationVehicleUpdateRequest, oeamtcIdentityKey?: string, options?: any) {
        return NotificationsApiFp(this.configuration).changeVehicleNotifications(vehicleId, requestBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the available notification channels for a user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getAvailableNotificationChannels(oeamtcIdentityKey?: string, options?: any) {
        return NotificationsApiFp(this.configuration).getAvailableNotificationChannels(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the possible notification events with their activated channels for a specific vehicle
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getVehicleNotifications(vehicleId: number, oeamtcIdentityKey?: string, options?: any) {
        return NotificationsApiFp(this.configuration).getVehicleNotifications(vehicleId, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PilotApi - axios parameter creator
 * @export
 */
export const PilotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a pilot
         * @param {PilotMutation} pilotCreateBody The pilot to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPilot: async (pilotCreateBody: PilotMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pilotCreateBody' is not null or undefined
            if (pilotCreateBody === null || pilotCreateBody === undefined) {
                throw new RequiredError('pilotCreateBody','Required parameter pilotCreateBody was null or undefined when calling createPilot.');
            }
            const localVarPath = `/pilots`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pilotCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pilotCreateBody !== undefined ? pilotCreateBody : {}) : (pilotCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single pilot by id owned by the given user
         * @summary Delete a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePilot: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePilot.');
            }
            const localVarPath = `/pilots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single pilot by id owned by the given user
         * @summary Get a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPilot: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPilot.');
            }
            const localVarPath = `/pilots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the suggested pilots for the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPilotSuggestions: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/pilotSuggestions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the pilots owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPilots: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/pilots`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a pilot by id owned by the given user
         * @summary Update a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {PilotMutation} pilotUpdateBody The pilot properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePilot: async (id: number, pilotUpdateBody: PilotMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePilot.');
            }
            // verify required parameter 'pilotUpdateBody' is not null or undefined
            if (pilotUpdateBody === null || pilotUpdateBody === undefined) {
                throw new RequiredError('pilotUpdateBody','Required parameter pilotUpdateBody was null or undefined when calling updatePilot.');
            }
            const localVarPath = `/pilots/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof pilotUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pilotUpdateBody !== undefined ? pilotUpdateBody : {}) : (pilotUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PilotApi - functional programming interface
 * @export
 */
export const PilotApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a pilot
         * @param {PilotMutation} pilotCreateBody The pilot to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPilot(pilotCreateBody: PilotMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pilot>> {
            const localVarAxiosArgs = await PilotApiAxiosParamCreator(configuration).createPilot(pilotCreateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a single pilot by id owned by the given user
         * @summary Delete a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePilot(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PilotApiAxiosParamCreator(configuration).deletePilot(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single pilot by id owned by the given user
         * @summary Get a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPilot(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pilot>> {
            const localVarAxiosArgs = await PilotApiAxiosParamCreator(configuration).getPilot(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the suggested pilots for the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPilotSuggestions(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PilotMutation>>> {
            const localVarAxiosArgs = await PilotApiAxiosParamCreator(configuration).getPilotSuggestions(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the pilots owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPilots(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pilot>>> {
            const localVarAxiosArgs = await PilotApiAxiosParamCreator(configuration).getPilots(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a pilot by id owned by the given user
         * @summary Update a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {PilotMutation} pilotUpdateBody The pilot properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePilot(id: number, pilotUpdateBody: PilotMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pilot>> {
            const localVarAxiosArgs = await PilotApiAxiosParamCreator(configuration).updatePilot(id, pilotUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PilotApi - factory interface
 * @export
 */
export const PilotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a pilot
         * @param {PilotMutation} pilotCreateBody The pilot to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPilot(pilotCreateBody: PilotMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Pilot> {
            return PilotApiFp(configuration).createPilot(pilotCreateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single pilot by id owned by the given user
         * @summary Delete a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePilot(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return PilotApiFp(configuration).deletePilot(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single pilot by id owned by the given user
         * @summary Get a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPilot(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Pilot> {
            return PilotApiFp(configuration).getPilot(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the suggested pilots for the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPilotSuggestions(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<PilotMutation>> {
            return PilotApiFp(configuration).getPilotSuggestions(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the pilots owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPilots(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<Pilot>> {
            return PilotApiFp(configuration).getPilots(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a pilot by id owned by the given user
         * @summary Update a pilot
         * @param {number} id The entity\&#39;s primary id
         * @param {PilotMutation} pilotUpdateBody The pilot properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePilot(id: number, pilotUpdateBody: PilotMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Pilot> {
            return PilotApiFp(configuration).updatePilot(id, pilotUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PilotApi - object-oriented interface
 * @export
 * @class PilotApi
 * @extends {BaseAPI}
 */
export class PilotApi extends BaseAPI {
    /**
     * 
     * @summary Create a pilot
     * @param {PilotMutation} pilotCreateBody The pilot to be created
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotApi
     */
    public createPilot(pilotCreateBody: PilotMutation, oeamtcIdentityKey?: string, options?: any) {
        return PilotApiFp(this.configuration).createPilot(pilotCreateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single pilot by id owned by the given user
     * @summary Delete a pilot
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotApi
     */
    public deletePilot(id: number, oeamtcIdentityKey?: string, options?: any) {
        return PilotApiFp(this.configuration).deletePilot(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single pilot by id owned by the given user
     * @summary Get a pilot
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotApi
     */
    public getPilot(id: number, oeamtcIdentityKey?: string, options?: any) {
        return PilotApiFp(this.configuration).getPilot(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the suggested pilots for the user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotApi
     */
    public getPilotSuggestions(oeamtcIdentityKey?: string, options?: any) {
        return PilotApiFp(this.configuration).getPilotSuggestions(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the pilots owned by the user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotApi
     */
    public getPilots(oeamtcIdentityKey?: string, options?: any) {
        return PilotApiFp(this.configuration).getPilots(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a pilot by id owned by the given user
     * @summary Update a pilot
     * @param {number} id The entity\&#39;s primary id
     * @param {PilotMutation} pilotUpdateBody The pilot properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PilotApi
     */
    public updatePilot(id: number, pilotUpdateBody: PilotMutation, oeamtcIdentityKey?: string, options?: any) {
        return PilotApiFp(this.configuration).updatePilot(id, pilotUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * QuickActionApi - axios parameter creator
 * @export
 */
export const QuickActionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns tags ordered by their usage frequency for quick categorization of a trip
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickActionTags: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/quick-action/tags`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickActionApi - functional programming interface
 * @export
 */
export const QuickActionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns tags ordered by their usage frequency for quick categorization of a trip
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuickActionTags(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tag>>> {
            const localVarAxiosArgs = await QuickActionApiAxiosParamCreator(configuration).getQuickActionTags(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QuickActionApi - factory interface
 * @export
 */
export const QuickActionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns tags ordered by their usage frequency for quick categorization of a trip
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickActionTags(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<Tag>> {
            return QuickActionApiFp(configuration).getQuickActionTags(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickActionApi - object-oriented interface
 * @export
 * @class QuickActionApi
 * @extends {BaseAPI}
 */
export class QuickActionApi extends BaseAPI {
    /**
     * 
     * @summary Returns tags ordered by their usage frequency for quick categorization of a trip
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickActionApi
     */
    public getQuickActionTags(oeamtcIdentityKey?: string, options?: any) {
        return QuickActionApiFp(this.configuration).getQuickActionTags(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RuleApi - axios parameter creator
 * @export
 */
export const RuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new personal rule
         * @summary Create new personal rule
         * @param {RuleMutation} ruleCreateBody The rule to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule: async (ruleCreateBody: RuleMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleCreateBody' is not null or undefined
            if (ruleCreateBody === null || ruleCreateBody === undefined) {
                throw new RequiredError('ruleCreateBody','Required parameter ruleCreateBody was null or undefined when calling createRule.');
            }
            const localVarPath = `/rules`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ruleCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ruleCreateBody !== undefined ? ruleCreateBody : {}) : (ruleCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single rule by id owned by the given user
         * @summary Delete a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule: async (id: string, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteRule.');
            }
            const localVarPath = `/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single rule by id owned by the given user
         * @summary Get a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule: async (id: string, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getRule.');
            }
            const localVarPath = `/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get personal rules of user
         * @summary Returns personal rules
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/rules`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a rule by id owned by the given user
         * @summary Update a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleMutation} ruleUpdateBody The rule properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule: async (id: string, ruleUpdateBody: RuleMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateRule.');
            }
            // verify required parameter 'ruleUpdateBody' is not null or undefined
            if (ruleUpdateBody === null || ruleUpdateBody === undefined) {
                throw new RequiredError('ruleUpdateBody','Required parameter ruleUpdateBody was null or undefined when calling updateRule.');
            }
            const localVarPath = `/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ruleUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ruleUpdateBody !== undefined ? ruleUpdateBody : {}) : (ruleUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a rule active state of a user
         * @summary Update a rule to set it either active or inactive
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleActive} request The resource to process
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleActive: async (id: string, request: RuleActive, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateRuleActive.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling updateRuleActive.');
            }
            const localVarPath = `/rules/{id}/active`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleApi - functional programming interface
 * @export
 */
export const RuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create new personal rule
         * @summary Create new personal rule
         * @param {RuleMutation} ruleCreateBody The rule to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRule(ruleCreateBody: RuleMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rule>> {
            const localVarAxiosArgs = await RuleApiAxiosParamCreator(configuration).createRule(ruleCreateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a single rule by id owned by the given user
         * @summary Delete a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRule(id: string, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await RuleApiAxiosParamCreator(configuration).deleteRule(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single rule by id owned by the given user
         * @summary Get a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRule(id: string, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rule>> {
            const localVarAxiosArgs = await RuleApiAxiosParamCreator(configuration).getRule(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get personal rules of user
         * @summary Returns personal rules
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRules(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rule>>> {
            const localVarAxiosArgs = await RuleApiAxiosParamCreator(configuration).getRules(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a rule by id owned by the given user
         * @summary Update a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleMutation} ruleUpdateBody The rule properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRule(id: string, ruleUpdateBody: RuleMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rule>> {
            const localVarAxiosArgs = await RuleApiAxiosParamCreator(configuration).updateRule(id, ruleUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a rule active state of a user
         * @summary Update a rule to set it either active or inactive
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleActive} request The resource to process
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRuleActive(id: string, request: RuleActive, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await RuleApiAxiosParamCreator(configuration).updateRuleActive(id, request, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RuleApi - factory interface
 * @export
 */
export const RuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create new personal rule
         * @summary Create new personal rule
         * @param {RuleMutation} ruleCreateBody The rule to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule(ruleCreateBody: RuleMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Rule> {
            return RuleApiFp(configuration).createRule(ruleCreateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single rule by id owned by the given user
         * @summary Delete a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule(id: string, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return RuleApiFp(configuration).deleteRule(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single rule by id owned by the given user
         * @summary Get a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule(id: string, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Rule> {
            return RuleApiFp(configuration).getRule(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get personal rules of user
         * @summary Returns personal rules
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<Rule>> {
            return RuleApiFp(configuration).getRules(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a rule by id owned by the given user
         * @summary Update a rule
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleMutation} ruleUpdateBody The rule properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule(id: string, ruleUpdateBody: RuleMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Rule> {
            return RuleApiFp(configuration).updateRule(id, ruleUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a rule active state of a user
         * @summary Update a rule to set it either active or inactive
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleActive} request The resource to process
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleActive(id: string, request: RuleActive, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return RuleApiFp(configuration).updateRuleActive(id, request, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleApi - object-oriented interface
 * @export
 * @class RuleApi
 * @extends {BaseAPI}
 */
export class RuleApi extends BaseAPI {
    /**
     * Create new personal rule
     * @summary Create new personal rule
     * @param {RuleMutation} ruleCreateBody The rule to be created
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public createRule(ruleCreateBody: RuleMutation, oeamtcIdentityKey?: string, options?: any) {
        return RuleApiFp(this.configuration).createRule(ruleCreateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single rule by id owned by the given user
     * @summary Delete a rule
     * @param {string} id The entity\&#39;s primary id as string
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public deleteRule(id: string, oeamtcIdentityKey?: string, options?: any) {
        return RuleApiFp(this.configuration).deleteRule(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single rule by id owned by the given user
     * @summary Get a rule
     * @param {string} id The entity\&#39;s primary id as string
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public getRule(id: string, oeamtcIdentityKey?: string, options?: any) {
        return RuleApiFp(this.configuration).getRule(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get personal rules of user
     * @summary Returns personal rules
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public getRules(oeamtcIdentityKey?: string, options?: any) {
        return RuleApiFp(this.configuration).getRules(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a rule by id owned by the given user
     * @summary Update a rule
     * @param {string} id The entity\&#39;s primary id as string
     * @param {RuleMutation} ruleUpdateBody The rule properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public updateRule(id: string, ruleUpdateBody: RuleMutation, oeamtcIdentityKey?: string, options?: any) {
        return RuleApiFp(this.configuration).updateRule(id, ruleUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a rule active state of a user
     * @summary Update a rule to set it either active or inactive
     * @param {string} id The entity\&#39;s primary id as string
     * @param {RuleActive} request The resource to process
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleApi
     */
    public updateRuleActive(id: string, request: RuleActive, oeamtcIdentityKey?: string, options?: any) {
        return RuleApiFp(this.configuration).updateRuleActive(id, request, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RuleV2Api - axios parameter creator
 * @export
 */
export const RuleV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new personal v2 rule
         * @summary Create new personal v2 rule
         * @param {RuleV2Mutation} ruleV2CreateBody The rule v2 to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleV2: async (ruleV2CreateBody: RuleV2Mutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleV2CreateBody' is not null or undefined
            if (ruleV2CreateBody === null || ruleV2CreateBody === undefined) {
                throw new RequiredError('ruleV2CreateBody','Required parameter ruleV2CreateBody was null or undefined when calling createRuleV2.');
            }
            const localVarPath = `/v2/rules`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ruleV2CreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ruleV2CreateBody !== undefined ? ruleV2CreateBody : {}) : (ruleV2CreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single rule v2 by id owned by the given user
         * @summary Get a rule v2
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleV2: async (id: string, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getRuleV2.');
            }
            const localVarPath = `/v2/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get personal v2 rules of user
         * @summary Returns personal v2 rules
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRulesV2: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/rules`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a rule v2 by id owned by the given user
         * @summary Update a rule v2
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleV2Mutation} request The rule v2 properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleV2: async (id: string, request: RuleV2Mutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateRuleV2.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling updateRuleV2.');
            }
            const localVarPath = `/v2/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleV2Api - functional programming interface
 * @export
 */
export const RuleV2ApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create new personal v2 rule
         * @summary Create new personal v2 rule
         * @param {RuleV2Mutation} ruleV2CreateBody The rule v2 to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRuleV2(ruleV2CreateBody: RuleV2Mutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleV2>> {
            const localVarAxiosArgs = await RuleV2ApiAxiosParamCreator(configuration).createRuleV2(ruleV2CreateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single rule v2 by id owned by the given user
         * @summary Get a rule v2
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleV2(id: string, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleV2>> {
            const localVarAxiosArgs = await RuleV2ApiAxiosParamCreator(configuration).getRuleV2(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get personal v2 rules of user
         * @summary Returns personal v2 rules
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRulesV2(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleV2>>> {
            const localVarAxiosArgs = await RuleV2ApiAxiosParamCreator(configuration).getRulesV2(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a rule v2 by id owned by the given user
         * @summary Update a rule v2
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleV2Mutation} request The rule v2 properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRuleV2(id: string, request: RuleV2Mutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleV2>> {
            const localVarAxiosArgs = await RuleV2ApiAxiosParamCreator(configuration).updateRuleV2(id, request, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RuleV2Api - factory interface
 * @export
 */
export const RuleV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create new personal v2 rule
         * @summary Create new personal v2 rule
         * @param {RuleV2Mutation} ruleV2CreateBody The rule v2 to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRuleV2(ruleV2CreateBody: RuleV2Mutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<RuleV2> {
            return RuleV2ApiFp(configuration).createRuleV2(ruleV2CreateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single rule v2 by id owned by the given user
         * @summary Get a rule v2
         * @param {string} id The entity\&#39;s primary id as string
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleV2(id: string, oeamtcIdentityKey?: string, options?: any): AxiosPromise<RuleV2> {
            return RuleV2ApiFp(configuration).getRuleV2(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get personal v2 rules of user
         * @summary Returns personal v2 rules
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRulesV2(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<RuleV2>> {
            return RuleV2ApiFp(configuration).getRulesV2(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a rule v2 by id owned by the given user
         * @summary Update a rule v2
         * @param {string} id The entity\&#39;s primary id as string
         * @param {RuleV2Mutation} request The rule v2 properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRuleV2(id: string, request: RuleV2Mutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<RuleV2> {
            return RuleV2ApiFp(configuration).updateRuleV2(id, request, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleV2Api - object-oriented interface
 * @export
 * @class RuleV2Api
 * @extends {BaseAPI}
 */
export class RuleV2Api extends BaseAPI {
    /**
     * Create new personal v2 rule
     * @summary Create new personal v2 rule
     * @param {RuleV2Mutation} ruleV2CreateBody The rule v2 to be created
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleV2Api
     */
    public createRuleV2(ruleV2CreateBody: RuleV2Mutation, oeamtcIdentityKey?: string, options?: any) {
        return RuleV2ApiFp(this.configuration).createRuleV2(ruleV2CreateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single rule v2 by id owned by the given user
     * @summary Get a rule v2
     * @param {string} id The entity\&#39;s primary id as string
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleV2Api
     */
    public getRuleV2(id: string, oeamtcIdentityKey?: string, options?: any) {
        return RuleV2ApiFp(this.configuration).getRuleV2(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get personal v2 rules of user
     * @summary Returns personal v2 rules
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleV2Api
     */
    public getRulesV2(oeamtcIdentityKey?: string, options?: any) {
        return RuleV2ApiFp(this.configuration).getRulesV2(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a rule v2 by id owned by the given user
     * @summary Update a rule v2
     * @param {string} id The entity\&#39;s primary id as string
     * @param {RuleV2Mutation} request The rule v2 properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleV2Api
     */
    public updateRuleV2(id: string, request: RuleV2Mutation, oeamtcIdentityKey?: string, options?: any) {
        return RuleV2ApiFp(this.configuration).updateRuleV2(id, request, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * StatisticApi - axios parameter creator
 * @export
 */
export const StatisticApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get categorical diagrams of trips such as statistics segmented by daytime, weekday, common road segment, tag, pilot, and end zone
         * @summary Returns categorical diagrams of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>} [filterCategory] filter which categories of data should be present in the diagrams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoricalDiagrams: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterCategory?: Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/diagrams/categorical`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterCategory) {
                localVarQueryParameter['filter.category'] = filterCategory.join(COLLECTION_FORMATS.csv);
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get highlights of trips such as maximum speed, longest duration, longest distance as well as most common tag, pilot, zone, route. Properties are null if no trips are found
         * @summary Returns highlights of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsHighlights: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/highlights`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get route geometries of trips.
         * @summary Returns route geometries (polylines) of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsRouteGeometries: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/routeGeometries`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get descriptive statistics (total sum, mean, std, etc.) regarding trips attributes (trip count, distance, speed, duration and parking time) aggregated by trips, day, week and months. Every property except tripCount may be null if no trips are found.
         * @summary Returns descriptive statistics of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsSummary: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/summary`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get time diagrams of trips such as statistics segmented by day, week, month and year
         * @summary Returns time diagrams of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {Array<'daily' | 'weekly' | 'monthly' | 'yearly'>} [filterFrequency] filter which frequency of data should be present in the diagrams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeDiagrams: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterFrequency?: Array<'daily' | 'weekly' | 'monthly' | 'yearly'>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/statistics/diagrams/time`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterFrequency) {
                localVarQueryParameter['filter.frequency'] = filterFrequency.join(COLLECTION_FORMATS.csv);
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticApi - functional programming interface
 * @export
 */
export const StatisticApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get categorical diagrams of trips such as statistics segmented by daytime, weekday, common road segment, tag, pilot, and end zone
         * @summary Returns categorical diagrams of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>} [filterCategory] filter which categories of data should be present in the diagrams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoricalDiagrams(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterCategory?: Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsCategoricalDiagrams>> {
            const localVarAxiosArgs = await StatisticApiAxiosParamCreator(configuration).getCategoricalDiagrams(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterCategory, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get highlights of trips such as maximum speed, longest duration, longest distance as well as most common tag, pilot, zone, route. Properties are null if no trips are found
         * @summary Returns highlights of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatisticsHighlights(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsHighlights>> {
            const localVarAxiosArgs = await StatisticApiAxiosParamCreator(configuration).getStatisticsHighlights(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get route geometries of trips.
         * @summary Returns route geometries (polylines) of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatisticsRouteGeometries(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsRouteGeometries>> {
            const localVarAxiosArgs = await StatisticApiAxiosParamCreator(configuration).getStatisticsRouteGeometries(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get descriptive statistics (total sum, mean, std, etc.) regarding trips attributes (trip count, distance, speed, duration and parking time) aggregated by trips, day, week and months. Every property except tripCount may be null if no trips are found.
         * @summary Returns descriptive statistics of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatisticsSummary(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsSummary>> {
            const localVarAxiosArgs = await StatisticApiAxiosParamCreator(configuration).getStatisticsSummary(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get time diagrams of trips such as statistics segmented by day, week, month and year
         * @summary Returns time diagrams of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {Array<'daily' | 'weekly' | 'monthly' | 'yearly'>} [filterFrequency] filter which frequency of data should be present in the diagrams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeDiagrams(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterFrequency?: Array<'daily' | 'weekly' | 'monthly' | 'yearly'>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatisticsTimeDiagrams>> {
            const localVarAxiosArgs = await StatisticApiAxiosParamCreator(configuration).getTimeDiagrams(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterFrequency, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StatisticApi - factory interface
 * @export
 */
export const StatisticApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get categorical diagrams of trips such as statistics segmented by daytime, weekday, common road segment, tag, pilot, and end zone
         * @summary Returns categorical diagrams of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>} [filterCategory] filter which categories of data should be present in the diagrams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoricalDiagrams(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterCategory?: Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>, options?: any): AxiosPromise<StatisticsCategoricalDiagrams> {
            return StatisticApiFp(configuration).getCategoricalDiagrams(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterCategory, options).then((request) => request(axios, basePath));
        },
        /**
         * Get highlights of trips such as maximum speed, longest duration, longest distance as well as most common tag, pilot, zone, route. Properties are null if no trips are found
         * @summary Returns highlights of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsHighlights(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any): AxiosPromise<StatisticsHighlights> {
            return StatisticApiFp(configuration).getStatisticsHighlights(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options).then((request) => request(axios, basePath));
        },
        /**
         * Get route geometries of trips.
         * @summary Returns route geometries (polylines) of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsRouteGeometries(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any): AxiosPromise<StatisticsRouteGeometries> {
            return StatisticApiFp(configuration).getStatisticsRouteGeometries(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options).then((request) => request(axios, basePath));
        },
        /**
         * Get descriptive statistics (total sum, mean, std, etc.) regarding trips attributes (trip count, distance, speed, duration and parking time) aggregated by trips, day, week and months. Every property except tripCount may be null if no trips are found.
         * @summary Returns descriptive statistics of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsSummary(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any): AxiosPromise<StatisticsSummary> {
            return StatisticApiFp(configuration).getStatisticsSummary(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options).then((request) => request(axios, basePath));
        },
        /**
         * Get time diagrams of trips such as statistics segmented by day, week, month and year
         * @summary Returns time diagrams of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {Array<'daily' | 'weekly' | 'monthly' | 'yearly'>} [filterFrequency] filter which frequency of data should be present in the diagrams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeDiagrams(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterFrequency?: Array<'daily' | 'weekly' | 'monthly' | 'yearly'>, options?: any): AxiosPromise<StatisticsTimeDiagrams> {
            return StatisticApiFp(configuration).getTimeDiagrams(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterFrequency, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticApi - object-oriented interface
 * @export
 * @class StatisticApi
 * @extends {BaseAPI}
 */
export class StatisticApi extends BaseAPI {
    /**
     * Get categorical diagrams of trips such as statistics segmented by daytime, weekday, common road segment, tag, pilot, and end zone
     * @summary Returns categorical diagrams of trips
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>} [filterCategory] filter which categories of data should be present in the diagrams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticApi
     */
    public getCategoricalDiagrams(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterCategory?: Array<'daytime' | 'weekday' | 'commonRoadSegment' | 'tag' | 'pilot' | 'endZone' | 'route'>, options?: any) {
        return StatisticApiFp(this.configuration).getCategoricalDiagrams(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterCategory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get highlights of trips such as maximum speed, longest duration, longest distance as well as most common tag, pilot, zone, route. Properties are null if no trips are found
     * @summary Returns highlights of trips
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticApi
     */
    public getStatisticsHighlights(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any) {
        return StatisticApiFp(this.configuration).getStatisticsHighlights(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get route geometries of trips.
     * @summary Returns route geometries (polylines) of trips
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticApi
     */
    public getStatisticsRouteGeometries(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any) {
        return StatisticApiFp(this.configuration).getStatisticsRouteGeometries(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get descriptive statistics (total sum, mean, std, etc.) regarding trips attributes (trip count, distance, speed, duration and parking time) aggregated by trips, day, week and months. Every property except tripCount may be null if no trips are found.
     * @summary Returns descriptive statistics of trips
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticApi
     */
    public getStatisticsSummary(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, options?: any) {
        return StatisticApiFp(this.configuration).getStatisticsSummary(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get time diagrams of trips such as statistics segmented by day, week, month and year
     * @summary Returns time diagrams of trips
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {Array<'daily' | 'weekly' | 'monthly' | 'yearly'>} [filterFrequency] filter which frequency of data should be present in the diagrams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticApi
     */
    public getTimeDiagrams(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterFrequency?: Array<'daily' | 'weekly' | 'monthly' | 'yearly'>, options?: any) {
        return StatisticApiFp(this.configuration).getTimeDiagrams(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterFrequency, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TagApi - axios parameter creator
 * @export
 */
export const TagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a tag
         * @param {TagMutation} tagCreateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: async (tagCreateBody: TagMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tagCreateBody' is not null or undefined
            if (tagCreateBody === null || tagCreateBody === undefined) {
                throw new RequiredError('tagCreateBody','Required parameter tagCreateBody was null or undefined when calling createTag.');
            }
            const localVarPath = `/tags`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tagCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tagCreateBody !== undefined ? tagCreateBody : {}) : (tagCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single tag by id owned by the given user
         * @summary Delete a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteTag.');
            }
            const localVarPath = `/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single tag by id owned by the given user
         * @summary Get a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTag.');
            }
            const localVarPath = `/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the tags owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a tag by id owned by the given user
         * @summary Update a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {TagMutation} tagUpdateBody The tag\&#39;s properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: async (id: number, tagUpdateBody: TagMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTag.');
            }
            // verify required parameter 'tagUpdateBody' is not null or undefined
            if (tagUpdateBody === null || tagUpdateBody === undefined) {
                throw new RequiredError('tagUpdateBody','Required parameter tagUpdateBody was null or undefined when calling updateTag.');
            }
            const localVarPath = `/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tagUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tagUpdateBody !== undefined ? tagUpdateBody : {}) : (tagUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagApi - functional programming interface
 * @export
 */
export const TagApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a tag
         * @param {TagMutation} tagCreateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTag(tagCreateBody: TagMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tag>> {
            const localVarAxiosArgs = await TagApiAxiosParamCreator(configuration).createTag(tagCreateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a single tag by id owned by the given user
         * @summary Delete a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTag(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TagApiAxiosParamCreator(configuration).deleteTag(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single tag by id owned by the given user
         * @summary Get a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTag(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tag>> {
            const localVarAxiosArgs = await TagApiAxiosParamCreator(configuration).getTag(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the tags owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tag>>> {
            const localVarAxiosArgs = await TagApiAxiosParamCreator(configuration).getTags(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a tag by id owned by the given user
         * @summary Update a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {TagMutation} tagUpdateBody The tag\&#39;s properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTag(id: number, tagUpdateBody: TagMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tag>> {
            const localVarAxiosArgs = await TagApiAxiosParamCreator(configuration).updateTag(id, tagUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TagApi - factory interface
 * @export
 */
export const TagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a tag
         * @param {TagMutation} tagCreateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(tagCreateBody: TagMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Tag> {
            return TagApiFp(configuration).createTag(tagCreateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single tag by id owned by the given user
         * @summary Delete a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return TagApiFp(configuration).deleteTag(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single tag by id owned by the given user
         * @summary Get a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Tag> {
            return TagApiFp(configuration).getTag(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the tags owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<Tag>> {
            return TagApiFp(configuration).getTags(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a tag by id owned by the given user
         * @summary Update a tag
         * @param {number} id The entity\&#39;s primary id
         * @param {TagMutation} tagUpdateBody The tag\&#39;s properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(id: number, tagUpdateBody: TagMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Tag> {
            return TagApiFp(configuration).updateTag(id, tagUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
export class TagApi extends BaseAPI {
    /**
     * 
     * @summary Create a tag
     * @param {TagMutation} tagCreateBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public createTag(tagCreateBody: TagMutation, oeamtcIdentityKey?: string, options?: any) {
        return TagApiFp(this.configuration).createTag(tagCreateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single tag by id owned by the given user
     * @summary Delete a tag
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public deleteTag(id: number, oeamtcIdentityKey?: string, options?: any) {
        return TagApiFp(this.configuration).deleteTag(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single tag by id owned by the given user
     * @summary Get a tag
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public getTag(id: number, oeamtcIdentityKey?: string, options?: any) {
        return TagApiFp(this.configuration).getTag(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the tags owned by the user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public getTags(oeamtcIdentityKey?: string, options?: any) {
        return TagApiFp(this.configuration).getTags(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a tag by id owned by the given user
     * @summary Update a tag
     * @param {number} id The entity\&#39;s primary id
     * @param {TagMutation} tagUpdateBody The tag\&#39;s properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public updateTag(id: number, tagUpdateBody: TagMutation, oeamtcIdentityKey?: string, options?: any) {
        return TagApiFp(this.configuration).updateTag(id, tagUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TripApi - axios parameter creator
 * @export
 */
export const TripApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create a trip for the given user corresponding to the given vehicle
         * @summary Create a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip: async (vehicleId: number, tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling createTrip.');
            }
            // verify required parameter 'tripCreateBody' is not null or undefined
            if (tripCreateBody === null || tripCreateBody === undefined) {
                throw new RequiredError('tripCreateBody','Required parameter tripCreateBody was null or undefined when calling createTrip.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (validateConflict !== undefined) {
                localVarQueryParameter['validateConflict'] = validateConflict;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tripCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tripCreateBody !== undefined ? tripCreateBody : {}) : (tripCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post a trip merge between two trips
         * @summary Post a trip merge
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TripIdPair} tripMergeRequestBody Pair of trip ids corresponding to trips to merge
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripMerge: async (vehicleId: number, tripMergeRequestBody: TripIdPair, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling createTripMerge.');
            }
            // verify required parameter 'tripMergeRequestBody' is not null or undefined
            if (tripMergeRequestBody === null || tripMergeRequestBody === undefined) {
                throw new RequiredError('tripMergeRequestBody','Required parameter tripMergeRequestBody was null or undefined when calling createTripMerge.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips/merge`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tripMergeRequestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tripMergeRequestBody !== undefined ? tripMergeRequestBody : {}) : (tripMergeRequestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a trip for the given user
         * @summary Create a trip
         * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripSkipVehicleId: async (tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tripCreateBody' is not null or undefined
            if (tripCreateBody === null || tripCreateBody === undefined) {
                throw new RequiredError('tripCreateBody','Required parameter tripCreateBody was null or undefined when calling createTripSkipVehicleId.');
            }
            const localVarPath = `/trips`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (validateConflict !== undefined) {
                localVarQueryParameter['validateConflict'] = validateConflict;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tripCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tripCreateBody !== undefined ? tripCreateBody : {}) : (tripCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single trip by id owned by the given user
         * @summary Delete a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip: async (vehicleId: number, id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling deleteTrip.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteTrip.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single trip by id owned by the given user
         * @summary Delete a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripSkipVehicleId: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteTripSkipVehicleId.');
            }
            const localVarPath = `/trips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single trip by id owned by the given user
         * @summary Get a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrip: async (vehicleId: number, id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getTrip.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTrip.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get error in a triplog for a particular vehicle, filterable by start and end time
         * @summary Returns errors in the given tripLog
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripErrors: async (vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getTripErrors.');
            }
            const localVarPath = `/vehicles/{vehicleId}/tripErrors`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single trip by id owned by the given user
         * @summary Get a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripSkipVehicleId: async (id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTripSkipVehicleId.');
            }
            const localVarPath = `/trips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include) {
                localVarQueryParameter['include'] = include.join(COLLECTION_FORMATS.csv);
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
         * @summary Returns summarized information of trips
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripSummarized: async (vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getTripSummarized.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips/summary`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterTagIds !== undefined) {
                localVarQueryParameter['filter.tagIds'] = filterTagIds;
            }

            if (filterPilotIds !== undefined) {
                localVarQueryParameter['filter.pilotIds'] = filterPilotIds;
            }

            if (filterZoneIds !== undefined) {
                localVarQueryParameter['filter.zoneIds'] = filterZoneIds;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
         * @summary Returns summarized information of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripSummarizedSkipVehicleId: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trips/summary`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterTagIds !== undefined) {
                localVarQueryParameter['filter.tagIds'] = filterTagIds;
            }

            if (filterPilotIds !== undefined) {
                localVarQueryParameter['filter.pilotIds'] = filterPilotIds;
            }

            if (filterZoneIds !== undefined) {
                localVarQueryParameter['filter.zoneIds'] = filterZoneIds;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user trips for a particular vehicle, filterable by various criteria as well as sorting and pagination
         * @summary Returns paginated trips owned by the user and done by the vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {boolean} [filterFsl] trips with the fsl property with the according value.
         * @param {boolean} [filterWork] trips with the work property with the according value.
         * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
         * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
         * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
         * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrips: async (vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling getTrips.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterTagIds !== undefined) {
                localVarQueryParameter['filter.tagIds'] = filterTagIds;
            }

            if (filterPilotIds !== undefined) {
                localVarQueryParameter['filter.pilotIds'] = filterPilotIds;
            }

            if (filterZoneIds !== undefined) {
                localVarQueryParameter['filter.zoneIds'] = filterZoneIds;
            }

            if (filterFsl !== undefined) {
                localVarQueryParameter['filter.fsl'] = filterFsl;
            }

            if (filterWork !== undefined) {
                localVarQueryParameter['filter.work'] = filterWork;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (pageOffset !== undefined) {
                localVarQueryParameter['page.offset'] = pageOffset;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user trips filterable by various criteria as well as sorting and pagination
         * @summary Returns paginated trips owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {boolean} [filterFsl] trips with the fsl property with the according value.
         * @param {boolean} [filterWork] trips with the work property with the according value.
         * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
         * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
         * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
         * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripsSkipVehicleId: async (oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/trips`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterTagIds !== undefined) {
                localVarQueryParameter['filter.tagIds'] = filterTagIds;
            }

            if (filterPilotIds !== undefined) {
                localVarQueryParameter['filter.pilotIds'] = filterPilotIds;
            }

            if (filterZoneIds !== undefined) {
                localVarQueryParameter['filter.zoneIds'] = filterZoneIds;
            }

            if (filterFsl !== undefined) {
                localVarQueryParameter['filter.fsl'] = filterFsl;
            }

            if (filterWork !== undefined) {
                localVarQueryParameter['filter.work'] = filterWork;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (pageOffset !== undefined) {
                localVarQueryParameter['page.offset'] = pageOffset;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a trip by id owned by the given user
         * @summary Update a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {TripMutation} tripUpdateBody The trip properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrip: async (vehicleId: number, id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling updateTrip.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTrip.');
            }
            // verify required parameter 'tripUpdateBody' is not null or undefined
            if (tripUpdateBody === null || tripUpdateBody === undefined) {
                throw new RequiredError('tripUpdateBody','Required parameter tripUpdateBody was null or undefined when calling updateTrip.');
            }
            const localVarPath = `/vehicles/{vehicleId}/trips/{id}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (validateConflict !== undefined) {
                localVarQueryParameter['validateConflict'] = validateConflict;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tripUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tripUpdateBody !== undefined ? tripUpdateBody : {}) : (tripUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a trip by id owned by the given user
         * @summary Update a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {TripMutation} tripUpdateBody The trip properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripSkipVehicleId: async (id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTripSkipVehicleId.');
            }
            // verify required parameter 'tripUpdateBody' is not null or undefined
            if (tripUpdateBody === null || tripUpdateBody === undefined) {
                throw new RequiredError('tripUpdateBody','Required parameter tripUpdateBody was null or undefined when calling updateTripSkipVehicleId.');
            }
            const localVarPath = `/trips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (validateConflict !== undefined) {
                localVarQueryParameter['validateConflict'] = validateConflict;
            }

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tripUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tripUpdateBody !== undefined ? tripUpdateBody : {}) : (tripUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TripApi - functional programming interface
 * @export
 */
export const TripApiFp = function(configuration?: Configuration) {
    return {
        /**
         * create a trip for the given user corresponding to the given vehicle
         * @summary Create a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrip(vehicleId: number, tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).createTrip(vehicleId, tripCreateBody, oeamtcIdentityKey, validateConflict, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Post a trip merge between two trips
         * @summary Post a trip merge
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TripIdPair} tripMergeRequestBody Pair of trip ids corresponding to trips to merge
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTripMerge(vehicleId: number, tripMergeRequestBody: TripIdPair, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).createTripMerge(vehicleId, tripMergeRequestBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create a trip for the given user
         * @summary Create a trip
         * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTripSkipVehicleId(tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).createTripSkipVehicleId(tripCreateBody, oeamtcIdentityKey, validateConflict, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a single trip by id owned by the given user
         * @summary Delete a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrip(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).deleteTrip(vehicleId, id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a single trip by id owned by the given user
         * @summary Delete a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTripSkipVehicleId(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).deleteTripSkipVehicleId(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single trip by id owned by the given user
         * @summary Get a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrip(vehicleId: number, id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTrip(vehicleId, id, oeamtcIdentityKey, include, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get error in a triplog for a particular vehicle, filterable by start and end time
         * @summary Returns errors in the given tripLog
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTripErrors(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TripError>>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTripErrors(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single trip by id owned by the given user
         * @summary Get a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTripSkipVehicleId(id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTripSkipVehicleId(id, oeamtcIdentityKey, include, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
         * @summary Returns summarized information of trips
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTripSummarized(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsSummary>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTripSummarized(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
         * @summary Returns summarized information of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTripSummarizedSkipVehicleId(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsSummary>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTripSummarizedSkipVehicleId(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get user trips for a particular vehicle, filterable by various criteria as well as sorting and pagination
         * @summary Returns paginated trips owned by the user and done by the vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {boolean} [filterFsl] trips with the fsl property with the according value.
         * @param {boolean} [filterWork] trips with the work property with the according value.
         * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
         * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
         * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
         * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrips(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsPage>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTrips(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get user trips filterable by various criteria as well as sorting and pagination
         * @summary Returns paginated trips owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {boolean} [filterFsl] trips with the fsl property with the according value.
         * @param {boolean} [filterWork] trips with the work property with the according value.
         * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
         * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
         * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
         * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTripsSkipVehicleId(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsPage>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).getTripsSkipVehicleId(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a trip by id owned by the given user
         * @summary Update a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {TripMutation} tripUpdateBody The trip properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrip(vehicleId: number, id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).updateTrip(vehicleId, id, tripUpdateBody, oeamtcIdentityKey, validateConflict, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a trip by id owned by the given user
         * @summary Update a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {TripMutation} tripUpdateBody The trip properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTripSkipVehicleId(id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Trip>> {
            const localVarAxiosArgs = await TripApiAxiosParamCreator(configuration).updateTripSkipVehicleId(id, tripUpdateBody, oeamtcIdentityKey, validateConflict, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TripApi - factory interface
 * @export
 */
export const TripApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * create a trip for the given user corresponding to the given vehicle
         * @summary Create a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrip(vehicleId: number, tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): AxiosPromise<Trip> {
            return TripApiFp(configuration).createTrip(vehicleId, tripCreateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(axios, basePath));
        },
        /**
         * Post a trip merge between two trips
         * @summary Post a trip merge
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {TripIdPair} tripMergeRequestBody Pair of trip ids corresponding to trips to merge
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripMerge(vehicleId: number, tripMergeRequestBody: TripIdPair, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Trip> {
            return TripApiFp(configuration).createTripMerge(vehicleId, tripMergeRequestBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * create a trip for the given user
         * @summary Create a trip
         * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTripSkipVehicleId(tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): AxiosPromise<Trip> {
            return TripApiFp(configuration).createTripSkipVehicleId(tripCreateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single trip by id owned by the given user
         * @summary Delete a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrip(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return TripApiFp(configuration).deleteTrip(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single trip by id owned by the given user
         * @summary Delete a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTripSkipVehicleId(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return TripApiFp(configuration).deleteTripSkipVehicleId(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single trip by id owned by the given user
         * @summary Get a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrip(vehicleId: number, id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options?: any): AxiosPromise<GetTrip> {
            return TripApiFp(configuration).getTrip(vehicleId, id, oeamtcIdentityKey, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Get error in a triplog for a particular vehicle, filterable by start and end time
         * @summary Returns errors in the given tripLog
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripErrors(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options?: any): AxiosPromise<Array<TripError>> {
            return TripApiFp(configuration).getTripErrors(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single trip by id owned by the given user
         * @summary Get a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripSkipVehicleId(id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options?: any): AxiosPromise<GetTrip> {
            return TripApiFp(configuration).getTripSkipVehicleId(id, oeamtcIdentityKey, include, options).then((request) => request(axios, basePath));
        },
        /**
         * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
         * @summary Returns summarized information of trips
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripSummarized(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any): AxiosPromise<TripsSummary> {
            return TripApiFp(configuration).getTripSummarized(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
         * @summary Returns summarized information of trips
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripSummarizedSkipVehicleId(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any): AxiosPromise<TripsSummary> {
            return TripApiFp(configuration).getTripSummarizedSkipVehicleId(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user trips for a particular vehicle, filterable by various criteria as well as sorting and pagination
         * @summary Returns paginated trips owned by the user and done by the vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {boolean} [filterFsl] trips with the fsl property with the according value.
         * @param {boolean} [filterWork] trips with the work property with the according value.
         * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
         * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
         * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
         * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrips(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any): AxiosPromise<TripsPage> {
            return TripApiFp(configuration).getTrips(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user trips filterable by various criteria as well as sorting and pagination
         * @summary Returns paginated trips owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {number} [filterVehicleId] return trips belonging to given vehicle
         * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
         * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
         * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
         * @param {boolean} [filterFsl] trips with the fsl property with the according value.
         * @param {boolean} [filterWork] trips with the work property with the according value.
         * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
         * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
         * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
         * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTripsSkipVehicleId(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any): AxiosPromise<TripsPage> {
            return TripApiFp(configuration).getTripsSkipVehicleId(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a trip by id owned by the given user
         * @summary Update a trip
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {number} id The entity\&#39;s primary id
         * @param {TripMutation} tripUpdateBody The trip properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrip(vehicleId: number, id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): AxiosPromise<Trip> {
            return TripApiFp(configuration).updateTrip(vehicleId, id, tripUpdateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a trip by id owned by the given user
         * @summary Update a trip
         * @param {number} id The entity\&#39;s primary id
         * @param {TripMutation} tripUpdateBody The trip properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTripSkipVehicleId(id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any): AxiosPromise<Trip> {
            return TripApiFp(configuration).updateTripSkipVehicleId(id, tripUpdateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TripApi - object-oriented interface
 * @export
 * @class TripApi
 * @extends {BaseAPI}
 */
export class TripApi extends BaseAPI {
    /**
     * create a trip for the given user corresponding to the given vehicle
     * @summary Create a trip
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public createTrip(vehicleId: number, tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any) {
        return TripApiFp(this.configuration).createTrip(vehicleId, tripCreateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post a trip merge between two trips
     * @summary Post a trip merge
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {TripIdPair} tripMergeRequestBody Pair of trip ids corresponding to trips to merge
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public createTripMerge(vehicleId: number, tripMergeRequestBody: TripIdPair, oeamtcIdentityKey?: string, options?: any) {
        return TripApiFp(this.configuration).createTripMerge(vehicleId, tripMergeRequestBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create a trip for the given user
     * @summary Create a trip
     * @param {TripMutation} tripCreateBody trip to be created. Relationships are via id reference
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public createTripSkipVehicleId(tripCreateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any) {
        return TripApiFp(this.configuration).createTripSkipVehicleId(tripCreateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single trip by id owned by the given user
     * @summary Delete a trip
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public deleteTrip(vehicleId: number, id: number, oeamtcIdentityKey?: string, options?: any) {
        return TripApiFp(this.configuration).deleteTrip(vehicleId, id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single trip by id owned by the given user
     * @summary Delete a trip
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public deleteTripSkipVehicleId(id: number, oeamtcIdentityKey?: string, options?: any) {
        return TripApiFp(this.configuration).deleteTripSkipVehicleId(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single trip by id owned by the given user
     * @summary Get a trip
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTrip(vehicleId: number, id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options?: any) {
        return TripApiFp(this.configuration).getTrip(vehicleId, id, oeamtcIdentityKey, include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get error in a triplog for a particular vehicle, filterable by start and end time
     * @summary Returns errors in the given tripLog
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTripErrors(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, options?: any) {
        return TripApiFp(this.configuration).getTripErrors(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single trip by id owned by the given user
     * @summary Get a trip
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {Array<'previous' | 'next'>} [include] A comma separated list of resources to include. Supported values: \&#39;previous\&#39;, \&#39;next\&#39;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTripSkipVehicleId(id: number, oeamtcIdentityKey?: string, include?: Array<'previous' | 'next'>, options?: any) {
        return TripApiFp(this.configuration).getTripSkipVehicleId(id, oeamtcIdentityKey, include, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
     * @summary Returns summarized information of trips
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
     * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
     * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTripSummarized(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any) {
        return TripApiFp(this.configuration).getTripSummarized(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get summarized information regarding all trips such as total trip count, total distance and total trips duration
     * @summary Returns summarized information of trips
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
     * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
     * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTripSummarizedSkipVehicleId(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, options?: any) {
        return TripApiFp(this.configuration).getTripSummarizedSkipVehicleId(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user trips for a particular vehicle, filterable by various criteria as well as sorting and pagination
     * @summary Returns paginated trips owned by the user and done by the vehicle
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
     * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
     * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
     * @param {boolean} [filterFsl] trips with the fsl property with the according value.
     * @param {boolean} [filterWork] trips with the work property with the according value.
     * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
     * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
     * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
     * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTrips(vehicleId: number, oeamtcIdentityKey?: string, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any) {
        return TripApiFp(this.configuration).getTrips(vehicleId, oeamtcIdentityKey, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user trips filterable by various criteria as well as sorting and pagination
     * @summary Returns paginated trips owned by the user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {number} [filterVehicleId] return trips belonging to given vehicle
     * @param {string} [filterFrom] do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} [filterUntil] do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {string} [filterTagIds] If this parameter is given, it must be a comma separated list of tag ids. Then, returned trips must have at least one of the listed tags set.
     * @param {string} [filterPilotIds] If this parameter is given, it must be a comma separated list of pilot ids. Then, returned trips must have at least one of the listed pilots set.
     * @param {string} [filterZoneIds] If this parameter is given, it must be a comma separated list of zone ids. Then, returned trips must have at least one of the listed zones set either at their start or end.
     * @param {boolean} [filterFsl] trips with the fsl property with the according value.
     * @param {boolean} [filterWork] trips with the work property with the according value.
     * @param {'startTimestamp' | 'endTimestamp'} [sort] Field to sort on. Default is &#x60;&#x60;startTimestamp&#x60;&#x60; sorting. Acceptable values &#x3D; &#x60;&#x60;[\&quot;startTimestamp\&quot;, \&quot;endTimestamp\&quot;]&#x60;&#x60;
     * @param {'asc' | 'desc'} [order] Sort either ascending (asc) or descending (desc)
     * @param {number} [pageOffset] do skip as many result items from the beginning; Default: &#x60;&#x60;0&#x60;&#x60;.
     * @param {number} [pageLimit] do only return at most as many result items; Default: &#x60;&#x60;20&#x60;&#x60;. Minimum: 1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public getTripsSkipVehicleId(oeamtcIdentityKey?: string, filterVehicleId?: number, filterFrom?: string, filterUntil?: string, filterTagIds?: string, filterPilotIds?: string, filterZoneIds?: string, filterFsl?: boolean, filterWork?: boolean, sort?: 'startTimestamp' | 'endTimestamp', order?: 'asc' | 'desc', pageOffset?: number, pageLimit?: number, options?: any) {
        return TripApiFp(this.configuration).getTripsSkipVehicleId(oeamtcIdentityKey, filterVehicleId, filterFrom, filterUntil, filterTagIds, filterPilotIds, filterZoneIds, filterFsl, filterWork, sort, order, pageOffset, pageLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a trip by id owned by the given user
     * @summary Update a trip
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {number} id The entity\&#39;s primary id
     * @param {TripMutation} tripUpdateBody The trip properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public updateTrip(vehicleId: number, id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any) {
        return TripApiFp(this.configuration).updateTrip(vehicleId, id, tripUpdateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a trip by id owned by the given user
     * @summary Update a trip
     * @param {number} id The entity\&#39;s primary id
     * @param {TripMutation} tripUpdateBody The trip properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {boolean} [validateConflict] validate for overlaps or gaps in time/odometer (requires vehicleId)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public updateTripSkipVehicleId(id: number, tripUpdateBody: TripMutation, oeamtcIdentityKey?: string, validateConflict?: boolean, options?: any) {
        return TripApiFp(this.configuration).updateTripSkipVehicleId(id, tripUpdateBody, oeamtcIdentityKey, validateConflict, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TripLogApi - axios parameter creator
 * @export
 */
export const TripLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripLogsGet: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/tripLogs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TripLogApi - functional programming interface
 * @export
 */
export const TripLogApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tripLogsGet(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TripLog>>> {
            const localVarAxiosArgs = await TripLogApiAxiosParamCreator(configuration).tripLogsGet(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TripLogApi - factory interface
 * @export
 */
export const TripLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripLogsGet(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<TripLog>> {
            return TripLogApiFp(configuration).tripLogsGet(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TripLogApi - object-oriented interface
 * @export
 * @class TripLogApi
 * @extends {BaseAPI}
 */
export class TripLogApi extends BaseAPI {
    /**
     * 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripLogApi
     */
    public tripLogsGet(oeamtcIdentityKey?: string, options?: any) {
        return TripLogApiFp(this.configuration).tripLogsGet(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * VehicleApi - axios parameter creator
 * @export
 */
export const VehicleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartConnectVehicles: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/vehicles/smartconnect-properties`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates settings fuelCapacity for this particular vehicle
         * @summary Update settings fuelCapacity
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelCapacityUpdateBody} fuelCapacityUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFuelCapacity: async (vehicleId: number, fuelCapacityUpdateBody: FuelCapacityUpdateBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling setFuelCapacity.');
            }
            // verify required parameter 'fuelCapacityUpdateBody' is not null or undefined
            if (fuelCapacityUpdateBody === null || fuelCapacityUpdateBody === undefined) {
                throw new RequiredError('fuelCapacityUpdateBody','Required parameter fuelCapacityUpdateBody was null or undefined when calling setFuelCapacity.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelCapacity`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fuelCapacityUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fuelCapacityUpdateBody !== undefined ? fuelCapacityUpdateBody : {}) : (fuelCapacityUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates settings fuelConsumptionType for this particular vehicle
         * @summary Update settings fuelConsumptionType
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelConsumptionTypeUpdateBody} fuelConsumptionTypeUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFuelConsumptionType: async (vehicleId: number, fuelConsumptionTypeUpdateBody: FuelConsumptionTypeUpdateBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling setFuelConsumptionType.');
            }
            // verify required parameter 'fuelConsumptionTypeUpdateBody' is not null or undefined
            if (fuelConsumptionTypeUpdateBody === null || fuelConsumptionTypeUpdateBody === undefined) {
                throw new RequiredError('fuelConsumptionTypeUpdateBody','Required parameter fuelConsumptionTypeUpdateBody was null or undefined when calling setFuelConsumptionType.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelConsumptionType`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fuelConsumptionTypeUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fuelConsumptionTypeUpdateBody !== undefined ? fuelConsumptionTypeUpdateBody : {}) : (fuelConsumptionTypeUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates settings fuelUnit for this particular vehicle
         * @summary Update settings fuelUnit
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelUnitUpdateBody} fuelUnitUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFuelUnit: async (vehicleId: number, fuelUnitUpdateBody: FuelUnitUpdateBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling setFuelUnit.');
            }
            // verify required parameter 'fuelUnitUpdateBody' is not null or undefined
            if (fuelUnitUpdateBody === null || fuelUnitUpdateBody === undefined) {
                throw new RequiredError('fuelUnitUpdateBody','Required parameter fuelUnitUpdateBody was null or undefined when calling setFuelUnit.');
            }
            const localVarPath = `/vehicles/{vehicleId}/fuelUnit`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fuelUnitUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fuelUnitUpdateBody !== undefined ? fuelUnitUpdateBody : {}) : (fuelUnitUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates setting mergeBreakThreshold for this particular vehicle
         * @summary Update setting mergeBreakThreshold
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {MergeBreakThresholdUpdateBody} mergeBreakThresholdUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMergeBreakThreshold: async (vehicleId: number, mergeBreakThresholdUpdateBody: MergeBreakThresholdUpdateBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling setMergeBreakThreshold.');
            }
            // verify required parameter 'mergeBreakThresholdUpdateBody' is not null or undefined
            if (mergeBreakThresholdUpdateBody === null || mergeBreakThresholdUpdateBody === undefined) {
                throw new RequiredError('mergeBreakThresholdUpdateBody','Required parameter mergeBreakThresholdUpdateBody was null or undefined when calling setMergeBreakThreshold.');
            }
            const localVarPath = `/vehicles/{vehicleId}/mergeBreakThreshold`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof mergeBreakThresholdUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(mergeBreakThresholdUpdateBody !== undefined ? mergeBreakThresholdUpdateBody : {}) : (mergeBreakThresholdUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {VehicleSeedOdometerUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSeedOdometer: async (vehicleId: number, requestBody: VehicleSeedOdometerUpdateRequest, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling setSeedOdometer.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling setSeedOdometer.');
            }
            const localVarPath = `/vehicles/{vehicleId}/seedOdometer`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set the state of the setup for a specific users vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {SetupRequestUpdate} request The resource to process
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetup: async (vehicleId: number, request: SetupRequestUpdate, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling setSetup.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling setSetup.');
            }
            const localVarPath = `/vehicles/{vehicleId}/setup`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates settings fuelStopSuggestions for this particular vehicle
         * @summary Update settings fuelStopSuggestions
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelStopSuggestionsUpdateBody} fuelStopSuggestionsUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFuelStopSuggestions: async (vehicleId: number, fuelStopSuggestionsUpdateBody: FuelStopSuggestionsUpdateBody, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            if (vehicleId === null || vehicleId === undefined) {
                throw new RequiredError('vehicleId','Required parameter vehicleId was null or undefined when calling toggleFuelStopSuggestions.');
            }
            // verify required parameter 'fuelStopSuggestionsUpdateBody' is not null or undefined
            if (fuelStopSuggestionsUpdateBody === null || fuelStopSuggestionsUpdateBody === undefined) {
                throw new RequiredError('fuelStopSuggestionsUpdateBody','Required parameter fuelStopSuggestionsUpdateBody was null or undefined when calling toggleFuelStopSuggestions.');
            }
            const localVarPath = `/vehicles/{vehicleId}/toggleFuelStopSuggestions`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=UTF-8';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fuelStopSuggestionsUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fuelStopSuggestionsUpdateBody !== undefined ? fuelStopSuggestionsUpdateBody : {}) : (fuelStopSuggestionsUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleApi - functional programming interface
 * @export
 */
export const VehicleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmartConnectVehicles(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SmartConnectVehicle>>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).getSmartConnectVehicles(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates settings fuelCapacity for this particular vehicle
         * @summary Update settings fuelCapacity
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelCapacityUpdateBody} fuelCapacityUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFuelCapacity(vehicleId: number, fuelCapacityUpdateBody: FuelCapacityUpdateBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).setFuelCapacity(vehicleId, fuelCapacityUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates settings fuelConsumptionType for this particular vehicle
         * @summary Update settings fuelConsumptionType
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelConsumptionTypeUpdateBody} fuelConsumptionTypeUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFuelConsumptionType(vehicleId: number, fuelConsumptionTypeUpdateBody: FuelConsumptionTypeUpdateBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).setFuelConsumptionType(vehicleId, fuelConsumptionTypeUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates settings fuelUnit for this particular vehicle
         * @summary Update settings fuelUnit
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelUnitUpdateBody} fuelUnitUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFuelUnit(vehicleId: number, fuelUnitUpdateBody: FuelUnitUpdateBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).setFuelUnit(vehicleId, fuelUnitUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates setting mergeBreakThreshold for this particular vehicle
         * @summary Update setting mergeBreakThreshold
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {MergeBreakThresholdUpdateBody} mergeBreakThresholdUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMergeBreakThreshold(vehicleId: number, mergeBreakThresholdUpdateBody: MergeBreakThresholdUpdateBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).setMergeBreakThreshold(vehicleId, mergeBreakThresholdUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {VehicleSeedOdometerUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSeedOdometer(vehicleId: number, requestBody: VehicleSeedOdometerUpdateRequest, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).setSeedOdometer(vehicleId, requestBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary set the state of the setup for a specific users vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {SetupRequestUpdate} request The resource to process
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSetup(vehicleId: number, request: SetupRequestUpdate, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).setSetup(vehicleId, request, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Updates settings fuelStopSuggestions for this particular vehicle
         * @summary Update settings fuelStopSuggestions
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelStopSuggestionsUpdateBody} fuelStopSuggestionsUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleFuelStopSuggestions(vehicleId: number, fuelStopSuggestionsUpdateBody: FuelStopSuggestionsUpdateBody, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await VehicleApiAxiosParamCreator(configuration).toggleFuelStopSuggestions(vehicleId, fuelStopSuggestionsUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * VehicleApi - factory interface
 * @export
 */
export const VehicleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartConnectVehicles(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<SmartConnectVehicle>> {
            return VehicleApiFp(configuration).getSmartConnectVehicles(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates settings fuelCapacity for this particular vehicle
         * @summary Update settings fuelCapacity
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelCapacityUpdateBody} fuelCapacityUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFuelCapacity(vehicleId: number, fuelCapacityUpdateBody: FuelCapacityUpdateBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).setFuelCapacity(vehicleId, fuelCapacityUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates settings fuelConsumptionType for this particular vehicle
         * @summary Update settings fuelConsumptionType
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelConsumptionTypeUpdateBody} fuelConsumptionTypeUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFuelConsumptionType(vehicleId: number, fuelConsumptionTypeUpdateBody: FuelConsumptionTypeUpdateBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).setFuelConsumptionType(vehicleId, fuelConsumptionTypeUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates settings fuelUnit for this particular vehicle
         * @summary Update settings fuelUnit
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelUnitUpdateBody} fuelUnitUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFuelUnit(vehicleId: number, fuelUnitUpdateBody: FuelUnitUpdateBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).setFuelUnit(vehicleId, fuelUnitUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates setting mergeBreakThreshold for this particular vehicle
         * @summary Update setting mergeBreakThreshold
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {MergeBreakThresholdUpdateBody} mergeBreakThresholdUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMergeBreakThreshold(vehicleId: number, mergeBreakThresholdUpdateBody: MergeBreakThresholdUpdateBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).setMergeBreakThreshold(vehicleId, mergeBreakThresholdUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {VehicleSeedOdometerUpdateRequest} requestBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSeedOdometer(vehicleId: number, requestBody: VehicleSeedOdometerUpdateRequest, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).setSeedOdometer(vehicleId, requestBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set the state of the setup for a specific users vehicle
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {SetupRequestUpdate} request The resource to process
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSetup(vehicleId: number, request: SetupRequestUpdate, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).setSetup(vehicleId, request, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates settings fuelStopSuggestions for this particular vehicle
         * @summary Update settings fuelStopSuggestions
         * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
         * @param {FuelStopSuggestionsUpdateBody} fuelStopSuggestionsUpdateBody 
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFuelStopSuggestions(vehicleId: number, fuelStopSuggestionsUpdateBody: FuelStopSuggestionsUpdateBody, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return VehicleApiFp(configuration).toggleFuelStopSuggestions(vehicleId, fuelStopSuggestionsUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleApi - object-oriented interface
 * @export
 * @class VehicleApi
 * @extends {BaseAPI}
 */
export class VehicleApi extends BaseAPI {
    /**
     * 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public getSmartConnectVehicles(oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).getSmartConnectVehicles(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates settings fuelCapacity for this particular vehicle
     * @summary Update settings fuelCapacity
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {FuelCapacityUpdateBody} fuelCapacityUpdateBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public setFuelCapacity(vehicleId: number, fuelCapacityUpdateBody: FuelCapacityUpdateBody, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).setFuelCapacity(vehicleId, fuelCapacityUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates settings fuelConsumptionType for this particular vehicle
     * @summary Update settings fuelConsumptionType
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {FuelConsumptionTypeUpdateBody} fuelConsumptionTypeUpdateBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public setFuelConsumptionType(vehicleId: number, fuelConsumptionTypeUpdateBody: FuelConsumptionTypeUpdateBody, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).setFuelConsumptionType(vehicleId, fuelConsumptionTypeUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates settings fuelUnit for this particular vehicle
     * @summary Update settings fuelUnit
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {FuelUnitUpdateBody} fuelUnitUpdateBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public setFuelUnit(vehicleId: number, fuelUnitUpdateBody: FuelUnitUpdateBody, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).setFuelUnit(vehicleId, fuelUnitUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates setting mergeBreakThreshold for this particular vehicle
     * @summary Update setting mergeBreakThreshold
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {MergeBreakThresholdUpdateBody} mergeBreakThresholdUpdateBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public setMergeBreakThreshold(vehicleId: number, mergeBreakThresholdUpdateBody: MergeBreakThresholdUpdateBody, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).setMergeBreakThreshold(vehicleId, mergeBreakThresholdUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {VehicleSeedOdometerUpdateRequest} requestBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public setSeedOdometer(vehicleId: number, requestBody: VehicleSeedOdometerUpdateRequest, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).setSeedOdometer(vehicleId, requestBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set the state of the setup for a specific users vehicle
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {SetupRequestUpdate} request The resource to process
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public setSetup(vehicleId: number, request: SetupRequestUpdate, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).setSetup(vehicleId, request, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates settings fuelStopSuggestions for this particular vehicle
     * @summary Update settings fuelStopSuggestions
     * @param {number} vehicleId The OEAMTC KFZ Vehicle Id
     * @param {FuelStopSuggestionsUpdateBody} fuelStopSuggestionsUpdateBody 
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public toggleFuelStopSuggestions(vehicleId: number, fuelStopSuggestionsUpdateBody: FuelStopSuggestionsUpdateBody, oeamtcIdentityKey?: string, options?: any) {
        return VehicleApiFp(this.configuration).toggleFuelStopSuggestions(vehicleId, fuelStopSuggestionsUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ZoneApi - axios parameter creator
 * @export
 */
export const ZoneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a zone
         * @param {ZoneMutation} zoneCreateBody The zone to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZone: async (zoneCreateBody: ZoneMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoneCreateBody' is not null or undefined
            if (zoneCreateBody === null || zoneCreateBody === undefined) {
                throw new RequiredError('zoneCreateBody','Required parameter zoneCreateBody was null or undefined when calling createZone.');
            }
            const localVarPath = `/zones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof zoneCreateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(zoneCreateBody !== undefined ? zoneCreateBody : {}) : (zoneCreateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single zone by id owned by the given user
         * @summary Delete a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteZone: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteZone.');
            }
            const localVarPath = `/zones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single zone by id owned by the given user
         * @summary Get a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZone: async (id: number, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getZone.');
            }
            const localVarPath = `/zones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the zones owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZones: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/zones`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the suggested zones for the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZonesSuggestions: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/zoneSuggestions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger GIS Favorite Synchronization, returns a synchronization result
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerGisFavoriteSynchronization: async (oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/zones/favoriteSynchronization`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a zone by id owned by the given user
         * @summary Update a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {ZoneMutation} zoneUpdateBody The zone properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZone: async (id: number, zoneUpdateBody: ZoneMutation, oeamtcIdentityKey?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateZone.');
            }
            // verify required parameter 'zoneUpdateBody' is not null or undefined
            if (zoneUpdateBody === null || zoneUpdateBody === undefined) {
                throw new RequiredError('zoneUpdateBody','Required parameter zoneUpdateBody was null or undefined when calling updateZone.');
            }
            const localVarPath = `/zones/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oeamtcIdentityKey !== undefined && oeamtcIdentityKey !== null) {
                localVarHeaderParameter['oeamtc-identity-key'] = String(oeamtcIdentityKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof zoneUpdateBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(zoneUpdateBody !== undefined ? zoneUpdateBody : {}) : (zoneUpdateBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoneApi - functional programming interface
 * @export
 */
export const ZoneApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a zone
         * @param {ZoneMutation} zoneCreateBody The zone to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createZone(zoneCreateBody: ZoneMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Zone>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).createZone(zoneCreateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a single zone by id owned by the given user
         * @summary Delete a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteZone(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).deleteZone(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a single zone by id owned by the given user
         * @summary Get a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZone(id: number, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Zone>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).getZone(id, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the zones owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZones(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Zone>>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).getZones(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns the suggested zones for the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZonesSuggestions(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoneSuggestions>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).getZonesSuggestions(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Trigger GIS Favorite Synchronization, returns a synchronization result
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerGisFavoriteSynchronization(oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GisFavoriteSynchronizationResult>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).triggerGisFavoriteSynchronization(oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a zone by id owned by the given user
         * @summary Update a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {ZoneMutation} zoneUpdateBody The zone properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZone(id: number, zoneUpdateBody: ZoneMutation, oeamtcIdentityKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Zone>> {
            const localVarAxiosArgs = await ZoneApiAxiosParamCreator(configuration).updateZone(id, zoneUpdateBody, oeamtcIdentityKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ZoneApi - factory interface
 * @export
 */
export const ZoneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a zone
         * @param {ZoneMutation} zoneCreateBody The zone to be created
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZone(zoneCreateBody: ZoneMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Zone> {
            return ZoneApiFp(configuration).createZone(zoneCreateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single zone by id owned by the given user
         * @summary Delete a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteZone(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<void> {
            return ZoneApiFp(configuration).deleteZone(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single zone by id owned by the given user
         * @summary Get a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZone(id: number, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Zone> {
            return ZoneApiFp(configuration).getZone(id, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the zones owned by the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZones(oeamtcIdentityKey?: string, options?: any): AxiosPromise<Array<Zone>> {
            return ZoneApiFp(configuration).getZones(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the suggested zones for the user
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZonesSuggestions(oeamtcIdentityKey?: string, options?: any): AxiosPromise<ZoneSuggestions> {
            return ZoneApiFp(configuration).getZonesSuggestions(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger GIS Favorite Synchronization, returns a synchronization result
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerGisFavoriteSynchronization(oeamtcIdentityKey?: string, options?: any): AxiosPromise<GisFavoriteSynchronizationResult> {
            return ZoneApiFp(configuration).triggerGisFavoriteSynchronization(oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a zone by id owned by the given user
         * @summary Update a zone
         * @param {number} id The entity\&#39;s primary id
         * @param {ZoneMutation} zoneUpdateBody The zone properties to update
         * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZone(id: number, zoneUpdateBody: ZoneMutation, oeamtcIdentityKey?: string, options?: any): AxiosPromise<Zone> {
            return ZoneApiFp(configuration).updateZone(id, zoneUpdateBody, oeamtcIdentityKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoneApi - object-oriented interface
 * @export
 * @class ZoneApi
 * @extends {BaseAPI}
 */
export class ZoneApi extends BaseAPI {
    /**
     * 
     * @summary Create a zone
     * @param {ZoneMutation} zoneCreateBody The zone to be created
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public createZone(zoneCreateBody: ZoneMutation, oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).createZone(zoneCreateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single zone by id owned by the given user
     * @summary Delete a zone
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public deleteZone(id: number, oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).deleteZone(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single zone by id owned by the given user
     * @summary Get a zone
     * @param {number} id The entity\&#39;s primary id
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public getZone(id: number, oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).getZone(id, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the zones owned by the user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public getZones(oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).getZones(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the suggested zones for the user
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public getZonesSuggestions(oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).getZonesSuggestions(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger GIS Favorite Synchronization, returns a synchronization result
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public triggerGisFavoriteSynchronization(oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).triggerGisFavoriteSynchronization(oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a zone by id owned by the given user
     * @summary Update a zone
     * @param {number} id The entity\&#39;s primary id
     * @param {ZoneMutation} zoneUpdateBody The zone properties to update
     * @param {string} [oeamtcIdentityKey] The user\&#39;s identityKey - needs to be a valid UUID (RFC 4122)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoneApi
     */
    public updateZone(id: number, zoneUpdateBody: ZoneMutation, oeamtcIdentityKey?: string, options?: any) {
        return ZoneApiFp(this.configuration).updateZone(id, zoneUpdateBody, oeamtcIdentityKey, options).then((request) => request(this.axios, this.basePath));
    }

}


